export const personas = {
  common: {
    waitlistButton: "Indítsd el most – ingyen",
    bookingNote: "* A vendégek természetesen továbbra is tudnak telefonon vagy a weboldaladon keresztül hagyományos módon is időpontot foglalni, ha ezt preferálják.",
    scaleNote: "A Bespire tökéletes választás kis és nagy csapatoknak is - 1-től 20+ szakemberig skálázható",
  },
  sections: {
    solo: {
      badge: "Egyéni Szakembereknek",
      title: "Tökéletes egyéni szakembereknek",
      description: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az időpontokat, az ügyfeleket, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    },
    team: {
      badge: "Több Szakemberes Csapatoknak",
      title: "Komplex csapatkezelés egyszerűen",
      description: "Ha több szakember dolgozik, a Bespire segít koordinálni a csapatot.",
    },
    bookingSystem: {
      badge: "Minden funkció egy helyen",
      title: "Professzionális foglalási rendszer minden igényre",
      description: "Legyen szó egyéni kezelésről, páros szolgáltatásokról vagy komplex csapatról - a rendszer rugalmasan alkalmazkodik hozzád.",
    },
    noDownload: {
      badge: "Egyszerű a vendégeknek is",
      title: "A vendégeidnek nem kell semmit letölteniük",
      description: "Nincs több widget beágyazás, nincs külső rendszerbe irányítás, nincs külön app telepítés. Minden egyetlen, tökéletesen mobilra optimalizált felületen történik - a te brandinged alatt.",
      features: {
        noApp: {
          title: "Nincs app telepítés",
          description: "A vendégek a böngészőből foglalnak, fizetnek és kommunikálnak - egyetlen kattintással",
        },
        noWidget: {
          title: "Nincs külső widget",
          description: "A foglalási folyamat teljesen integrált, nem irányít át másik oldalra",
        },
        unified: {
          title: "Egységes élmény",
          description: "Ugyanaz a dizájn, ugyanaz a felület - a foglalástól a fizetésig minden a te márkád",
        },
      },
      phoneMockup: {
        url: "eroforma.hu/foglalas",
        businessName: "Erőforma Stúdió",
        tagline: "Személyi edzés & csoportos órák",
        selectService: "Válassz szolgáltatást",
        services: [
          { name: "Személyi edzés", duration: "60 perc", price: "12.000 Ft" },
          { name: "Csoportos edzés", duration: "45 perc", price: "4.000 Ft" },
          { name: "Online coaching", duration: "30 perc", price: "8.000 Ft" },
        ],
        selectTime: "Válassz időpontot",
        timeSlots: ["08:00", "09:30", "10:00", "11:30", "14:00", "16:00"],
        confirmed: "Foglalás megerősítve!",
        confirmedSubtext: "Emlékeztetőt küldünk SMS-ben",
        browserLabel: "Böngészőből, app nélkül",
        noAppNeeded: "Nem kellett app letöltés!",
      },
    },
    aiChat: {
      sectionTitle: "AI Chat Működés Közben",
      sectionSubtitle: "Íme néhány példa arra, hogyan működik az AI chat a mindennapi feladatokban",
      websiteBuilding: {
        badge: "Weboldal építés",
        title: "Chat-alapú weboldal készítés",
        description: "Beszélsz az AI-val és ő építi a weboldaladat. Nincs kódolás, nincs bonyolult szerkesztő - csak természetes beszélgetés.",
        features: [
          "Szekciók hozzáadása/módosítása beszélgetéssel",
          "Színek, betűtípusok egyszerű testreszabása",
          "Galéria, árlista, szolgáltatások automatikusan",
        ],
        aiAction: "AI létrehozza a szolgáltatások szekciót",
      },
      calendar: {
        badge: "Időpont kezelés",
        title: "AI kezeli a naptáradat",
        description: "Az AI asszisztens teljesen átveszi a foglalások, átütemezések, emlékeztetők kezelését. Te csak mondod neki mit akarsz.",
        features: [
          "Időpontok felvitele és módosítása chat-en",
          "Automatikus emlékeztetők küldése",
          "Vendég előzmények azonnali lekérése",
        ],
        aiAction: "AI azonnal megmutatja a szabad időpontokat",
      },
      marketing: {
        badge: "Marketing AI",
        title: "Automatikus marketing kampányok",
        description: "Az AI social media posztokat, email kampányokat és WhatsApp üzeneteket készít helyetted. Te csak jóváhagyod.",
        features: [
          "Heti Instagram és Facebook posztok",
          "Email kampányok inaktív vendégeknek",
          "Szezonális ajánlatok hirdetése",
        ],
        aiAction: "AI elkészíti a kampányt és célozza",
      },
      bottomHighlight: {
        title: "Minden chat-alapon, egyetlen helyen",
        description: "Nem kell 10 különböző eszközt használnod weboldal építéshez, naptár kezeléshez, marketinghez. Az AI chat mindent kezel - te csak beszélsz vele természetes nyelven, mint egy asszisztenssel, és ő mindent megold helyetted a háttérben.",
      },
    },
    bookingFlow: {
      badge: "Foglalási folyamat",
      title: "Időpont foglalás AI chattel lépésről lépésre",
      subtitle: "Nézd meg, milyen egyszerű a vendégeidnek időpontot foglalni",
      stepLabel: "Lépés",
      steps: [
        {
          step: "1",
          title: "Vendég ír az AI-nak",
          description: "A vendég a weboldaladon vagy WhatsApp-on keresztül ír az AI asszisztensnek természetes nyelven",
        },
        {
          step: "2",
          title: "AI megérti és javasol",
          description: "Az AI megnézi a naptáradat, látja a szabad időpontokat és felajánlja őket a vendégnek",
        },
        {
          step: "3",
          title: "Automatikus megerősítés",
          description: "Vendég választ, AI berakja a naptárba és küld megerősítő email-t és SMS-t is neki",
        },
        {
          step: "4",
          title: "Emlékeztető 24h előtt",
          description: "24 órával előtte automatikus emlékeztető, vendég megerősítheti vagy módosíthatja",
        },
      ],
    },
    marketing: {
      title: "Marketing ami magától megy",
      description: "Automatizált promóciók, szezonális ajánlatok és visszajelzés-kérések - az AI mindent időzít és személyre szab helyetted.",
      features: [
        {
          title: "Social media automatizálás",
          description: "AI készít heti 3 Instagram és Facebook posztot a galériádból. Hashtag-ek, leírások, időzített publikálás - minden automatikus.",
        },
        {
          title: "Email marketing",
          description: "Automatikus email-ek új vendégeknek, visszahívó üzenetek inaktív vendégeknek, születésnapi köszöntők ajándék kuponnal.",
        },
        {
          title: "WhatsApp üzenetek",
          description: "Last minute akciók, szezonális ajánlatok, újrahívó üzenetek - rövid, hatékony kommunikáció WhatsApp-on.",
        },
        {
          title: "TikTok kampány javaslatok",
          description: "AI elemzi a trendjeidet és konkrét javaslatokat tesz TikTok tartalmakra, videó ötletekre, hashtag stratégiákra - te döntöd el mit használsz.",
        },
      ],
      mockup: {
        header: "Marketing Automatizálás",
        subheader: "AI által vezérelt kampányok",
        aiActive: "AI aktív",
        aiDetected: "AI észlelés",
        opportunity: "28 inaktív ügyfelet találtam akik 2+ hónapja nem foglaltak. Kampányt javaslok 3 csatornán.",
        campaignsReady: "Elkészített kampányok",
        campaigns: [
          { channel: "Email", message: "\"Hiányzol! 🎁 Itt egy ingyenes edzés kupon...\"", audience: "28 fő" },
          { channel: "WhatsApp", message: "\"Szia! Van egy ajándékunk neked 💪\"", audience: "22 fő" },
          { channel: "Instagram", message: "\"Visszavárunk! Limitált akció...\"", audience: "1.2K" },
        ],
        schedule: "Ütemezés",
        scheduleDays: ["Hé", "Ke", "Sze", "Cs", "Pé", "Szo", "Va"],
        sent: "Kampányok elindítva!",
        sentDetail: "3 csatorna · 28 ügyfél célozva",
        results: "Eredmények",
        live: "● Élő",
        stats: [
          { value: "82%", label: "Megnyitás" },
          { value: "12", label: "Visszafoglalt" },
          { value: "144K", label: "Bevétel" },
        ],
        roiTitle: "12x megtérülés automatikusan",
        roiSubtitle: "Teljesen AI által kezelve, beavatkozás nélkül",
      },
    },
    finances: {
      badge: "Pénzügyek",
      title: "Átlátható pénzügyek",
      description: "Online fizetés, automatikus számlázás, részletes kimutatások - minden egy helyen",
      features: [
        {
          title: "Bevételek kezelése",
          description: "Napi, heti, havi bevétel áttekintés. Szakemberenkénti bontás csapatokban.",
        },
        {
          title: "Online fizetés",
          description: "Előre fizetés bankkártyával, helyszíni fizetés, automatikus számlázás.",
        },
        {
          title: "Csomagok és bérletek",
          description: "Bérletek, szezonális csomagok, ajándékkuponok értékesítése.",
        },
      ],
      stats: {
        daily: "Napi",
        weekly: "Heti",
        monthly: "Havi",
        revenue: "bevétel",
        statistics: "statisztika",
        report: "kimutatás",
      },
    },
    sellProducts: {
      badge: "Értékesítési lehetőségek",
      title: "Mit értékesíthetsz?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak szolgáltatásokat tarthatsz, hanem digitális termékeket, kurzusokat és tanácsadást is értékesíthetsz",
    },
    cta: {
      title: "Készen állsz a váltásra?",
      description: "Készen állsz a váltásra? Indítsd el az oldalad most chatben az AI-val, vagy kérj visszahívást és mi felépítjük neked 48 óra alatt.",
      button: "Indítsd el most – ingyen",
      callbackButton: "Kérek visszahívást",
    },
  },
  bookingSystem: {
    tickets: {
      title: "Bérletek és fizetés",
      flexibleTickets: {
        title: "Rugalmas bérletrendszer",
        description: "Alkalmas, időkorlátos, korlátlan bérletek - automatikus levonással foglaláskor.",
      },
      onsitePayment: {
        title: "Helyszíni fizetés",
        description: "Készpénz vagy kártya a helyszínen - függőben lévő fizetések nyomon követése.",
      },
      invoicing: {
        title: "Számlázás beállítása",
        description: "Számlázó központhoz vagy szakemberekhez kötve - alvállalkozóknak is tökéletes.",
      },
    },
    staff: {
      title: "Szakemberek és jogosultságok",
      accounts: {
        title: "Szakember fiókok",
        description: "Saját naptár, foglalások, vendégek - mindenki csak azt látja, amihez joga van.",
      },
      transfer: {
        title: "Kezelés átadása egyszerűen",
        description: "Beteg a szakember? Pár kattintás és a vendégek automatikusan értesülnek.",
      },
      unlimited: {
        title: "Korlátlan szakember",
        description: "Adj hozzá amennyit szeretnél, nem fizetsz többet érte.",
      },
    },
    clients: {
      title: "Vendégkezelés és címkézés",
      tags: {
        title: "Szabad címkézés",
        description: "VIP, sportoló, krónikus... Az AI idővel automatikusan is címkéz.",
      },
      newClient: {
        title: "Új vendég rögzítése",
        description: "Nem regisztrált? Rögzítsd egyszerűen azonnal.",
      },
      bulkImport: {
        title: "Tömeges hozzáadás",
        description: "Akár 50 vendég egyszerre importálással.",
      },
    },
    services: {
      title: "Szolgáltatások és helyiségkezelés",
      visibility: {
        title: "Célzott megjelenítés",
        description: "Címke alapján szabályozható ki mit lát.",
      },
      rooms: {
        title: "Helyiségek kezelése",
        description: "Több helyiség, ütközésfigyelés, optimális kihasználtság.",
      },
    },
    coupons: {
      title: "Kuponok és partnerségek",
      codes: {
        title: "Kuponkódok",
        description: "Százalékos, fix összegű kedvezmények - lejárattal és limittel.",
      },
      corporate: {
        title: "Céges együttműködések",
        description: "Email domain alapú kuponok automatikus beváltással.",
      },
    },
    automation: {
      title: "Automatizációk és szabályok",
      cancellation: {
        title: "Automatikus lemondások",
        description: "Szabályok: meddig lehet lemondani, figyelmeztetés, nem fizetett foglalások törlése.",
      },
      waitlist: {
        title: "Várólista",
        description: "Megtelt a nap? Automatikus értesítés az első várakozónak ha felszabadul hely.",
      },
      logic: {
        title: "Foglalási logika",
        description: "Előre foglalás, minimum idő, ingyenes lemondás - mind testreszabható.",
      },
    },
    communication: {
      title: "Kommunikáció",
      templates: {
        title: "Email sablonok",
        description: "Visszaigazolás, emlékeztető, lemondás - a te stílusodban, logóddal.",
      },
      whatsapp: {
        title: "WhatsApp értesítések",
        description: "Automatikus üzenetek a vendégeknek, ahol tényleg olvassák.",
      },
      targeted: {
        title: "Célzott küldés",
        description: "VIP-eknek, lejáró bérleteseknek, inaktívaknak - címkék alapján.",
      },
    },
  },
  soloFeatures: {
    websiteBuilder: {
      title: "AI-al megépíted a weboldalad",
      description: "Beszélgetsz az AI-val és ő építi a weboldaladat. Nincs kódolás, nincs bonyolult szerkesztő - csak elmondod mit szeretnél és az AI megcsinálja. Ha már van weboldalad és rendszered, semmi gond: csak add meg az URL-t és a Bespire áthozza a képeket, leírásokat, mindent - és egy gyönyörű új weboldalt épít neked percek alatt.",
      details: [
        "Chat-alapú weboldal építés, nulla kódolással",
        "Meglévő weboldal importálása URL megadásával",
        "Színek, betűtípusok egyszerű testreszabása",
        "Galéria, árlista, szolgáltatások automatikusan",
      ],
    },
    calendar: {
      title: "Chat-alapú naptárkezelés",
      description: "Az AI asszisztensnek egyszerűen írsz chat-en keresztül amikor időpontot szeretnél felvinni, módosítani vagy törölni. Nem kell bonyolult admin felületen keresgélni - csak írd le mit szeretnél és az AI megcsinálja.",
      details: [
        "Időpontok felvitele egyszerű üzenettel",
        "Szolgáltatások és időtartamok kezelése",
        "Naptár áttekintés természetes nyelven",
        "Automatikus ütközéskezelés és figyelmeztetés",
      ],
    },
    clientManagement: {
      title: "Közös vendég- és szakember felület",
      description: "Minden vendég előzményei egy helyen: foglalások története, kezelések, személyes jegyzetek. A vendégek is saját felületet kapnak ahol látják bérleteiket, foglalásaikat és előzményeiket. Mindkét oldal naprakész, a rendszer mindig tudja így senkinek nem kell emlékeznie.",
      details: [
        "Teljes kezelési történet vendégenként",
        "Vendégek saját felülete bérletekkel és előzményekkel",
        "Személyes jegyzetek és információk",
        "Kapcsolattartási előzmények mindkét oldalról",
      ],
    },
    marketing: {
      title: "Marketing automatizálás",
      description: "AI készít social media posztokat, email kampányokat. Pl.: Hozza vissza azokat, akik 2 hónapja nem jártak nálad. Te csak jóváhagyod, a többi automatikus.",
      details: [
        "Heti Instagram és Facebook posztok",
        "Email kampányok inaktív vendégeknek",
        "Születésnapi köszöntők automatikusan",
        "Szezonális akciók hirdetése",
      ],
    },
  },
  teamFeatures: {
    multiStaff: {
      title: "Több szakember kezelése egyszerűen",
      description: "Minden szakember saját naptárral, ügyféllistával, statisztikával. Központi admin felületről mindent látsz, de mindenki csak azt látja, amit kell.",
      benefits: [
        "Szakemberenkénti külön naptár és ügyfélbázis",
        "Központi dashboard a tulajdonosnak",
        "Jogosultságkezelés: tulajdonos, manager, alkalmazott",
        "Valós idejű szinkronizáció",
      ],
    },
    aiCoordination: {
      title: "AI koordinálja a csapatot",
      description: "Az AI automatikusan osztja szét a foglalásokat a szakemberek között. Figyelembe veszi ki melyik szolgáltatást végzi, ki mikor van szabad.",
      benefits: [
        "Egy foglalás – automatikus szakember hozzárendelés",
        "Automatikus foglalás elosztás",
        "Szolgáltatás alapú hozzárendelés",
        "Átirányítás ha valaki beteg vagy nincs",
      ],
    },
    statistics: {
      title: "Átlátható statisztikák",
      description: "Melyik szakember mennyit dolgozott, ki hozott mennyi bevételt, melyik szolgáltatás a legnépszerűbb. Minden adat egy helyen, exportálható riportokban.",
      benefits: [
        "Szakemberenkénti teljesítmény statisztikák",
        "Bevételi kimutatások naponta/hetente/havonta",
        "Szolgáltatás népszerűségi toplista",
        "Exportálás Excel és PDF formátumban",
      ],
    },
    branding: {
      title: "Teljesen saját arculat, végig",
      description: "Nincs beágyazott külső időpontfoglaló, ami kilóg a dizájnból. Minden egységes megjelenéssel, a te márkáddal, ahogy te szeretnéd.",
      benefits: [
        "Saját logó, színek, betűtípusok mindenhol",
        "Nincs idegen widget vagy popup",
        "Egységes élmény a foglalástól a fizetésig",
        "Professzionális megjelenés minden érintkezési ponton",
      ],
    },
  },
  // Persona-specific content
  massageTherapists: {
    slug: "masszor",
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Online · Mindig elérhető",
        inputPlaceholder: "Írj egy üzenetet...",
        user1: "Készíts nekem egy weboldalt masszázs kezelésekkel és árakkal!",
        ai1: "Kész! Elkészítettem az oldaladat 3 szekcióval: hero, masszázsok és árlista. Itt az elérhetőséged: zenwellness.bespire.hu",
        user2: "Holnap 14:00-ra foglalj be Kovács Évát svéd masszázsra!",
        ai2: "Lefoglaltam! Kovács Éva - Svéd masszázs, holnap 14:00. Értesítést is küldtem neki.",
        user3: "Küldj emailt azoknak akik 2 hónapja nem jártak nálam!",
        ai3: "Elkészítettem a kampányt és kiküldtem 31 inaktív vendégnek. Már 85%-os a megnyitási arány!",
        user4: "Köszi, ez fantasztikus! 😍",
        ai4: "Szívesen! Ha bármi kell, csak szólj. Weboldal, naptár, vendégek, marketing - te csak masszírozz! 💆",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      domain: "zenwellness.bespire.hu",
      chatPrompt: "Építsd meg az oldalamat masszázsokkal és árakkal!",
      aiMsg1: "Persze! Elkezdtem építeni az oldaladat. Néhány másodperc és kész is lesz...",
      aiMsg2: "Elkészültek a szekciók:",
      doneLabel: "Kész! Az oldalad él és elérhető:",
      userFollowUp: "Tudnád a színeket arany és krém tónusra cserélni?",
      aiFollowUpReply: "Kész! Átállítottam a színeket arany és krém tónusra. Gyönyörű lett! 🌿",
      blocks: {
        hero: "Hero szekció",
        services: "Masszázs kezelések",
        pricing: "Árlista",
      },
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      synced: "Szinkronizálva",
      freeLabel: "Szabad",
      userAsk: "Holnap mik a szabad időpontjaim?",
      aiResponse: "Holnapi időpontjaid:",
      userBook: "Foglald le a 10:30-at Kovács Évának svéd masszázsra!",
      aiConfirm: "Kész! 10:30 lefoglalva Kovács Évának - Svéd masszázs",
      notifSent: "Értesítés elküldve a vendégnek",
      userThanks: "Köszönöm, szuper! 👍",
      days: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      slots: {
        slot1: "Nagy A. - Svéd masszázs",
        slot2: "Tóth P. - Sportmasszázs",
        slot3: "",
        slot4: "Kiss M. - Thai masszázs",
        slot5: "",
      },
      newBookingNotif: "Új foglalás érkezett: Szabó L. - Relaxációs 15:30",
    },
    clientsAnimation: {
      chatHeader: "Vendégkezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd meg Veres Emese profilját!",
      userAction: "Küldj neki emlékeztetőt a lejáró bérletéről!",
      aiConfirm: "Kész! Emlékeztető elküldve Veres Emesének",
      visitsLabel: "alkalom",
      clients: {
        client1: { name: "Veres Emese", tag: "VIP", status: "Aktív bérlet" },
        client2: { name: "Kovács Éva", tag: "Új", status: "Első masszázs" },
        client3: { name: "Nagy Anna", tag: "VIP", status: "10 alkalmas" },
        client4: { name: "Tóth Péter", tag: "Visszatérő", status: "Havi bérlet" },
      },
      tabs: {
        profile: "Profil",
        history: "Előzmények",
        notes: "Jegyzetek",
      },
      timeline: {
        firstVisit: "Első látogatás",
        passBought: "10 alkalmas bérlet",
        session: "Svéd masszázs #7",
        renewal: "Bérlet megújítás",
      },
      stats: {
        retention: "Megtartás",
        vipClients: "VIP vendég",
        growth: "Növekedés",
      },
    },
    marketingAnimation: {
      chatHeader: "Marketing",
      title: "Marketing automatizálás",
      subtitle: "AI asszisztens",
      userAsk: "Hozd vissza a 2 hónapja inaktív vendégeket!",
      aiCampaignIntro: "Elkészítettem a kampányt! Íme az email előnézet:",
      emailSubject: "Hiányzol nekünk!",
      emailPreview: "20% kedvezmény visszatérő vendégeknek",
      emailCta: "Foglalok!",
      userSend: "Küldd ki most! 🚀",
      aiSentConfirm: "Kiküldtem mind a 31 címre!",
      userReply: "Ez fantasztikus! 😍",
      sentLabel: "Kiküldve",
      opensLabel: "Megnyitás",
      funnel: {
        audience: "Célközönség",
        audienceDetail: "31 inaktív vendég",
        content: "Tartalom",
        contentDetail: "Visszatérő ajánlat email",
        sending: "Küldés",
        sendingDetail: "Kiküldve 31 címre",
        results: "Eredmények",
        resultsDetail: "85% megnyitás",
        resultTitle: "Kampány eredmény",
        live: "● Élő",
        conversions: "Visszatérő",
      },
    },
    teamAnimation: {
      chatHeader: "Csapatkezelés",
      chatSubheader: "AI asszisztens · Online",
      inputPlaceholder: "Írj egy üzenetet...",
      user1: "Mutasd a mai csapatot! Ki dolgozik ma?",
      ai1: "Íme a mai csapat állapota:",
      user2: "Hogy állunk ma a foglalásokkal?",
      ai2: "Íme a mai statisztikák:",
      user3: "Varga Lili beteg, oszd szét a kezeléseit a többiek között!",
      ai3: "Átszerveztem Varga Lili 4 kezelését a szabad terapeutákra.",
      user4: "Szuper, köszi! 🙌",
      ai4: "Szívesen! A vendégeket is értesítettem a terapeuta váltásról. Minden szinkronban van! 💆",
      reassignDone: "4 kezelés átirányítva · 4 vendég értesítve",
      statsBookings: "Mai foglalás",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Heti bevétel",
      staff: [
        { name: "Kis Anna", role: "Senior terapeuta", status: "Elérhető" },
        { name: "Nagy Bence", role: "Sportmasszőr", status: "Kezelésen" },
        { name: "Varga Lili", role: "Relaxációs terapeuta", status: "Beteg" },
        { name: "Fehér Márk", role: "Thai masszőr", status: "Elérhető" },
      ],
    },
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Solo masszőröknek és több terapeutás wellness központoknak is.",
    heroImageAlt: "Masszőr vendéggel dolgozik",
    soloBadge: "Solo Masszőröknek",
    soloTitle: "Tökéletes egyéni masszőröknek",
    soloDescription: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az időpontokat, a vendégeket, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Több Terapeutás Wellness Központoknak",
    teamTitle: "Komplex wellness központ kezelés egyszerűen",
    teamDescription: "Ha több terapeuta dolgozik a központban, a Bespire segít koordinálni a csapatot.",
    teamImageAlt: "Wellness csapat együttműködés",
    phoneDemo: {
      businessName: "Zen Wellness Spa",
      domain: "zenwellness.hu",
      serviceName: "Relaxációs masszázs",
      duration: "60 perc",
      price: "15.000 Ft",
      appointment: "Szombat, 11:00",
      therapist: "Anna",
      appointmentLabel: "Időpont",
      therapistLabel: "Terapeuta",
      confirmButton: "Foglalás megerősítése",
      url: "zenwellness.hu/foglalas",
      tagline: "Professzionális masszázs kezelések",
      selectService: "Válassz szolgáltatást",
      services: [
        { name: "Svéd masszázs", duration: "60 perc", price: "12.000 Ft" },
        { name: "Thai masszázs", duration: "90 perc", price: "18.000 Ft" },
        { name: "Sportmasszázs", duration: "45 perc", price: "10.000 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["09:00", "10:30", "12:00", "14:00", "16:00", "18:00"],
      confirmed: "Foglalás megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk SMS-ben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót a masszázs típusokkal és az árakkal",
        aiResponse: "Rendben! Készítettem egy szekciót a masszázs típusoknak. Svéd, thai, sportmasszázs - mindegyikhez külön leírás. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza a masszázs típusok szekciót",
      },
      calendar: {
        userMessage: "Holnap délután mik a szabad időpontjaim svéd masszázsra?",
        aiResponse: "Holnap délután 14:00, 16:00 és 17:30-kor van szabad időpontod 60 perces svéd masszázsra. Foglaljak valakinek?",
        aiAction: "AI azonnal megmutatja a szabad időpontokat",
      },
      marketing: {
        userMessage: "Csinálj egy email kampányt azoknak akik 2 hónapja nem jártak nálam, kínálj nekik 20% kedvezményt",
        aiResponse: "Találtam 31 inaktív vendéget. Email készült, benne a 20% kedvezmény kupon. Küldjük most vagy időzítsem holnap 9-re?",
        aiAction: "AI elkészíti a kampányt és célozza",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz masszőrként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak masszázsokat tarthatsz, hanem digitális termékeket, kurzusokat és tanácsadást is értékesíthetsz",
      products: [
        {
          emoji: "💆",
          title: "Masszázs Kezelések",
          description: "Az alapod - vendégeid online foglalhatnak időpontot minden kezelésedre",
          items: [
            "Svéd relaxációs masszázs",
            "Sportmasszázs, triggerpontos kezelés",
            "Thai masszázs, stretching",
            "Páros masszázs élmény",
          ],
        },
        {
          emoji: "💬",
          title: "Testtartás Tanácsadás",
          description: "Magasabb árkategória - online vagy személyes szakértői konzultáció",
          items: [
            "Testtartás elemzés és korrekció",
            "Fájdalomkezelési stratégia",
            "Ergonómiai tanácsadás irodai munkásoknak",
            "Otthoni nyújtási rutin összeállítás",
          ],
        },
        {
          emoji: "👥",
          title: "Wellness Workshopok",
          description: "Több embert érsz el egyszerre - magasabb bevétel, közösség építés",
          items: [
            "Páros masszázs tanfolyam",
            "Önmasszázs technikák workshop",
            "Stresszkezelés és relaxáció",
            "Wellness hétvége program",
          ],
        },
        {
          emoji: "📚",
          title: "Digitális Termékek",
          description: "Passzív bevétel - egyszer készíted, folyamatosan értékesíted",
          items: [
            "Önmasszázs útmutató PDF",
            "Nyújtási rutin videó csomag",
            "Relaxációs technikák e-book",
            "Otthoni wellness tippek",
          ],
        },
        {
          emoji: "🎫",
          title: "Bérletek és Csomagok",
          description: "Stabil, előre látható bevétel - lojális vendégek garantálva",
          items: [
            "10 alkalmas masszázs bérlet",
            "Havi wellness csomag",
            "VIP éves tagság",
            "Ajándékutalványok",
          ],
        },
      ],
    },
  },
  hairdressers: {
    slug: "fodrasz",
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Online · Mindig elérhető",
        inputPlaceholder: "Írj egy üzenetet...",
        user1: "Készíts nekem egy weboldalt szolgáltatásokkal és árakkal!",
        ai1: "Kész! Elkészítettem az oldaladat 3 szekcióval: hero, szolgáltatások és árlista. Itt az elérhetőséged: elegancehair.bespire.hu",
        user2: "Holnap 14:00-ra foglalj be Kovács Évát festésre!",
        ai2: "Lefoglaltam! Kovács Éva - Festés és vágás, holnap 14:00. Értesítést is küldtem neki.",
        user3: "Küldj emailt azoknak akik 2 hónapja nem jártak nálam!",
        ai3: "Elkészítettem a kampányt és kiküldtem 45 inaktív ügyfélnek. Már 78%-os a megnyitási arány!",
        user4: "Köszi, ez fantasztikus! 😍",
        ai4: "Szívesen! Ha bármi kell, csak szólj. Mindenben tudok segíteni: weboldal, naptár, ügyfelek, marketing - te csak alkoss! ✂️",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      domain: "elegancehair.bespire.hu",
      chatPrompt: "Építsd meg az oldalamat szolgáltatásokkal és árakkal!",
      aiMsg1: "Persze! Elkezdtem építeni az oldaladat. Néhány másodperc és kész is lesz...",
      aiMsg2: "Elkészültek a szekciók:",
      doneLabel: "Kész! Az oldalad él és elérhető:",
      userFollowUp: "Tudnád a színeket rózsaszínre és feketére cserélni?",
      aiFollowUpReply: "Kész! Átállítottam a színeket rózsaszínre és feketére. Nézd meg az oldalon! 🎨",
      blocks: {
        hero: "Hero szekció",
        services: "Szolgáltatások",
        pricing: "Árlista",
      },
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      synced: "Szinkronizálva",
      freeLabel: "Szabad",
      userAsk: "Holnap mik a szabad időpontjaim?",
      aiResponse: "Holnapi időpontjaid:",
      userBook: "Foglald le a 14:00-t Kovács Évának festésre!",
      aiConfirm: "Kész! 14:00 lefoglalva Kovács Évának",
      notifSent: "Értesítés elküldve az ügyfélnek",
      userThanks: "Köszönöm, szuper! 👍",
      days: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      slots: {
        slot1: "Nagy A. - Festés",
        slot2: "Tóth M. - Hajvágás",
        slot3: "Szabó K. - Melír",
        slot4: "Kiss R. - Alkalmi frizura",
        slot5: "Varga L. - Kezelés",
      },
      newBookingNotif: "Új foglalás érkezett: Kovács É. - Festés 14:00",
    },
    clientsAnimation: {
      chatHeader: "Ügyfélkezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd meg Nagy Anna profilját!",
      userAction: "Küldj neki emlékeztetőt a következő festési időpontjáról!",
      aiConfirm: "Kész! Emlékeztető elküldve Nagy Annának",
      visitsLabel: "alkalom",
      clients: {
        client1: { name: "Nagy Anna", tag: "VIP", status: "Törzs vendég" },
        client2: { name: "Kovács Éva", tag: "Új", status: "Első látogatás" },
        client3: { name: "Szabó Kata", tag: "VIP", status: "Havi bérlet" },
        client4: { name: "Kiss Réka", tag: "Visszatérő", status: "10 alkalmas" },
      },
      tabs: {
        profile: "Profil",
        history: "Előzmények",
        notes: "Jegyzetek",
      },
      timeline: {
        firstVisit: "Első látogatás",
        passBought: "5 alkalmas bérlet",
        session: "Festés + vágás #4",
        renewal: "Bérlet megújítás",
      },
      stats: {
        retention: "Megtartás",
        vipClients: "VIP ügyfél",
        growth: "Növekedés",
      },
    },
    teamAnimation: {
      chatHeader: "Szalon Kezelés",
      chatSubheader: "AI asszisztens · Online",
      inputPlaceholder: "Írj egy üzenetet...",
      user1: "Mutasd a mai csapatot! Ki dolgozik ma?",
      ai1: "Íme a mai szalon állapota:",
      user2: "Hogy állunk ma a foglalásokkal?",
      ai2: "Íme a mai statisztikák:",
      user3: "Lakatos Petra beteg, oszd szét az időpontjait a többiek között!",
      ai3: "Átszerveztem Lakatos Petra 6 időpontját a szabad fodrászokra.",
      user4: "Szuper, köszi! 🙌",
      ai4: "Szívesen! Az ügyfeleket is értesítettem a fodrászváltásról. Minden szinkronban van! ✂️",
      reassignDone: "6 időpont átirányítva · 4 ügyfél értesítve",
      statsBookings: "Mai foglalás",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Heti bevétel",
      staff: [
        { name: "Molnár Kata", role: "Senior stylist", status: "Elérhető" },
        { name: "Tóth Bence", role: "Borbély", status: "Vendéggel" },
        { name: "Lakatos Petra", role: "Colorist", status: "Beteg" },
        { name: "Kiss Dóra", role: "Junior stylist", status: "Elérhető" },
      ],
    },
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Solo fodrászoknak és több fodrászos szalonoknak is.",
    heroImageAlt: "Fodrász dolgozik ügyféllel",
    soloBadge: "Solo Fodrászoknak",
    soloTitle: "Tökéletes egyéni fodrászoknak & borbélyoknak",
    soloDescription: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az időpontokat, az ügyfeleket, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Több Fodrászos Szalonoknak",
    teamTitle: "Komplex szalonkezelés egyszerűen",
    teamDescription: "Ha több fodrász dolgozik a szalonodban, a Bespire segít koordinálni a csapatot.",
    teamImageAlt: "Szalon csapat együttműködés",
    phoneDemo: {
      businessName: "Elegance Hair Studio",
      domain: "elegancehair.hu",
      serviceName: "Festés és vágás",
      duration: "90 perc",
      price: "25.000 Ft",
      appointment: "Péntek, 14:00",
      therapist: "Kata",
      appointmentLabel: "Időpont",
      therapistLabel: "Stylist",
      confirmButton: "Foglalás megerősítése",
      url: "elegancehair.hu/foglalas",
      tagline: "Professzionális fodrász szolgáltatások",
      selectService: "Válassz szolgáltatást",
      services: [
        { name: "Festés és vágás", duration: "90 perc", price: "25.000 Ft" },
        { name: "Férfi hajvágás", duration: "30 perc", price: "5.000 Ft" },
        { name: "Melírozás", duration: "120 perc", price: "35.000 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["09:00", "10:30", "12:00", "14:00", "16:00", "18:00"],
      confirmed: "Foglalás megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk SMS-ben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót a hajvágás típusokkal és az árakkal",
        aiResponse: "Rendben! Készítettem egy szekciót a szolgáltatásoknak. Hajvágás, festés, melír - mindegyikhez külön leírás. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza a szolgáltatások szekciót",
      },
      calendar: {
        userMessage: "Holnap délután mik a szabad időpontjaim festésre?",
        aiResponse: "Holnap délután 13:00, 15:30 és 17:00-kor van szabad időpontod 90 perces festésre. Foglaljak valakinek?",
        aiAction: "AI azonnal megmutatja a szabad időpontokat",
      },
      marketing: {
        userMessage: "Csinálj egy email kampányt azoknak akik 2 hónapja nem jártak nálam, kínálj nekik 20% kedvezményt",
        aiResponse: "Találtam 45 inaktív ügyfelet. Email készült, benne a 20% kedvezmény kupon. Küldjük most vagy időzítsem holnap 9-re?",
        aiAction: "AI elkészíti a kampányt és célozza",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz fodrászként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak hajvágásokat tarthatsz, hanem digitális termékeket, kurzusokat és tanácsadást is értékesíthetsz",
      products: [
        {
          emoji: "✂️",
          title: "Fodrász Szolgáltatások",
          description: "Az alapod - ügyfeleid online foglalhatnak időpontot minden szolgáltatásodra",
          items: [
            "Hajvágás, formázás",
            "Festés, melír, balayage",
            "Alkalmi frizura",
            "Kezelések és ápolás",
          ],
        },
        {
          emoji: "💇",
          title: "Styling Tanácsadás",
          description: "Magasabb árkategória - személyre szabott stílus konzultáció",
          items: [
            "Arcformához illő frizura tanácsadás",
            "Otthoni hajápolás konzultáció",
            "Színtanácsadás",
            "Menyasszonyi stílus tervezés",
          ],
        },
        {
          emoji: "👥",
          title: "Workshopok",
          description: "Több embert érsz el egyszerre - magasabb bevétel, közösség építés",
          items: [
            "Otthoni hajformázás tanfolyam",
            "Fonási technikák workshop",
            "Hajápolás kezdőknek",
            "Styling masterclass",
          ],
        },
        {
          emoji: "📚",
          title: "Digitális Termékek",
          description: "Passzív bevétel - egyszer készíted, folyamatosan értékesíted",
          items: [
            "Hajápolási útmutató PDF",
            "Otthoni styling videó csomag",
            "Frizura inspiráció e-book",
            "Termék ajánlások katalógus",
          ],
        },
        {
          emoji: "🎫",
          title: "Bérletek és Csomagok",
          description: "Stabil, előre látható bevétel - lojális ügyfelek garantálva",
          items: [
            "5 alkalmas hajvágás bérlet",
            "Havi styling csomag",
            "VIP tagság extra kedvezményekkel",
            "Ajándékutalványok",
          ],
        },
      ],
    },
  },
  fitnessTrainers: {
    slug: "edzo",
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Online · Mindig elérhető",
        inputPlaceholder: "Írj egy üzenetet...",
        user1: "Készíts nekem egy weboldalt edzésekkel és árakkal!",
        ai1: "Kész! Elkészítettem az oldaladat 3 szekcióval: hero, edzések és árlista. Itt az elérhetőséged: fitpro-anna.bespire.hu",
        user2: "Holnap reggel 9-re foglalj be Szabó Dávidot személyi edzésre!",
        ai2: "Lefoglaltam! Szabó Dávid - Személyi edzés, holnap 9:00. Értesítést is küldtem neki.",
        user3: "Küldj emailt azoknak akik 2 hónapja nem jártak!",
        ai3: "Elkészítettem a kampányt és kiküldtem 28 inaktív ügyfélnek. Már 82%-os a megnyitási arány!",
        user4: "Köszi, ez fantasztikus! 😍",
        ai4: "Szívesen! Ha bármi kell, csak szólj. Mindenben tudok segíteni: weboldal, naptár, ügyfelek, marketing - te csak edzz! 💪",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      domain: "fitpro-anna.bespire.hu",
      chatPrompt: "Építsd meg az oldalamat edzésekkel és árakkal!",
      aiMsg1: "Persze! Elkezdtem építeni az oldaladat. Néhány másodperc és kész is lesz...",
      aiMsg2: "Elkészültek a szekciók:",
      doneLabel: "Kész! Az oldalad él és elérhető:",
      userFollowUp: "Tudnád a színeket zöldre és feketére cserélni?",
      aiFollowUpReply: "Kész! Átállítottam a színeket zöldre és feketére. Nézd meg az oldalon! 🎨",
      blocks: {
        hero: "Hero szekció",
        services: "Szolgáltatások",
        pricing: "Árlista",
      },
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      synced: "Szinkronizálva",
      freeLabel: "Szabad",
      userAsk: "Holnap mik a szabad időpontjaim?",
      aiResponse: "Holnapi időpontjaid:",
      userBook: "Foglald le a 9:00-t Szabó Dávidnak!",
      aiConfirm: "Kész! 09:00 lefoglalva Szabó Dávidnak",
      notifSent: "Értesítés elküldve az ügyfélnek",
      userThanks: "Köszönöm, szuper! 👍",
      days: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      slots: {
        slot1: "Kiss R. - Személyi",
        slot2: "Crossfit csoport (8 fő)",
        slot3: "Szabó D. - Kondíció",
        slot4: "TRX haladó (12 fő)",
        slot5: "HIIT kezdő (6 fő)",
      },
      newBookingNotif: "Új foglalás érkezett: Kovács B. - Személyi 16:00",
    },
    clientsAnimation: {
      chatHeader: "Ügyfélkezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd meg Kiss Réka profilját!",
      userAction: "Küldj neki emlékeztetőt a lejáró bérletéről!",
      aiConfirm: "Kész! Emlékeztető elküldve Kiss Rékának",
      visitsLabel: "alkalom",
      clients: {
        client1: { name: "Kiss Réka", tag: "VIP", status: "Aktív bérlet" },
        client2: { name: "Szabó Dávid", tag: "Új", status: "Próba edzés" },
        client3: { name: "Nagy Anna", tag: "VIP", status: "10 alkalmas" },
        client4: { name: "Tóth Péter", tag: "Visszatérő", status: "Havi bérlet" },
      },
      tabs: {
        profile: "Profil",
        history: "Előzmények",
        notes: "Jegyzetek",
      },
      timeline: {
        firstVisit: "Első látogatás",
        passBought: "10 alkalmas bérlet",
        session: "Személyi edzés #8",
        renewal: "Bérlet megújítás",
      },
      stats: {
        retention: "Megtartás",
        vipClients: "VIP ügyfél",
        growth: "Növekedés",
      },
    },
    marketingAnimation: {
      chatHeader: "Marketing",
      title: "Marketing automatizálás",
      subtitle: "AI asszisztens",
      userAsk: "Hozd vissza a 2 hónapja inaktív ügyfeleket!",
      aiCampaignIntro: "Elkészítettem a kampányt! Íme az email előnézet:",
      emailSubject: "Hiányzol nekünk!",
      emailPreview: "Ingyenes visszatérő edzés kupon",
      emailCta: "Foglalok!",
      userSend: "Küldd ki most! 🚀",
      aiSentConfirm: "Kiküldtem mind a 28 címre!",
      userReply: "Ez fantasztikus! 😍",
      sentLabel: "Kiküldve",
      opensLabel: "Megnyitás",
      funnel: {
        audience: "Célközönség",
        audienceDetail: "28 inaktív ügyfél",
        content: "Tartalom",
        contentDetail: "Visszatérő ajánlat email",
        sending: "Küldés",
        sendingDetail: "Kiküldve 28 címre",
        results: "Eredmények",
        resultsDetail: "82% megnyitás",
        resultTitle: "Kampány eredmény",
        live: "● Élő",
        conversions: "Visszatérő",
      },
    },
    teamAnimation: {
      chatHeader: "Csapatkezelés",
      chatSubheader: "AI asszisztens · Online",
      inputPlaceholder: "Írj egy üzenetet...",
      user1: "Mutasd a mai csapatot! Ki dolgozik ma?",
      ai1: "Íme a mai csapat állapota:",
      user2: "Hogy állunk ma a foglalásokkal?",
      ai2: "Íme a mai statisztikák:",
      user3: "Tóth Kata beteg, oszd szét az óráit a többiek között!",
      ai3: "Átszerveztem Tóth Kata 5 óráját a szabad edzőkre.",
      user4: "Szuper, köszi! 🙌",
      ai4: "Szívesen! Az ügyféleket is értesítettem az edzőváltásról. Minden szinkronban van! 💪",
      reassignDone: "5 óra átirányítva · 3 ügyfél értesítve",
      statsBookings: "Mai foglalás",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Heti bevétel",
      staff: [
        { name: "Kovács Anna", role: "Senior edző", status: "Elérhető" },
        { name: "Nagy Bence", role: "Személyi edző", status: "Edzésen" },
        { name: "Tóth Kata", role: "Csoportos edző", status: "Beteg" },
        { name: "Kiss Márk", role: "Fitness edző", status: "Elérhető" },
      ],
    },
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Solo edzőknek és több edzős fitness termeknek is.",
    heroImageAlt: "Fitness edző ügyféllel edz",
    soloBadge: "Solo Edzőknek",
    soloTitle: "Tökéletes személyi edzőknek",
    soloDescription: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az időpontokat, az ügyfeleket, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Több Edzős Fitness Termeknek",
    teamTitle: "Komplex fitness terem kezelés egyszerűen",
    teamDescription: "Ha több edző dolgozik a teremben, a Bespire segít koordinálni a csapatot.",
    teamImageAlt: "Fitness csapat együttműködés",
    phoneDemo: {
      businessName: "Erőforma Stúdió",
      domain: "eroforma.hu",
      serviceName: "Személyi edzés",
      duration: "60 perc",
      price: "12.000 Ft",
      appointment: "Hétfő, 08:00",
      therapist: "Márk",
      appointmentLabel: "Időpont",
      therapistLabel: "Edző",
      confirmButton: "Foglalás megerősítése",
      url: "eroforma.hu/foglalas",
      tagline: "Személyi edzés & csoportos órák",
      selectService: "Válassz szolgáltatást",
      services: [
        { name: "Személyi edzés", duration: "60 perc", price: "12.000 Ft" },
        { name: "Csoportos edzés", duration: "45 perc", price: "4.000 Ft" },
        { name: "Online coaching", duration: "30 perc", price: "8.000 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["08:00", "09:30", "10:00", "11:30", "14:00", "16:00"],
      confirmed: "Foglalás megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk SMS-ben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót az edzés típusokkal és az árakkal",
        aiResponse: "Rendben! Készítettem egy szekciót az edzéseknek. Személyi edzés, csoportos óra, online coaching - mindegyikhez külön leírás. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza az edzések szekciót",
      },
      calendar: {
        userMessage: "Holnap reggel mik a szabad időpontjaim személyi edzésre?",
        aiResponse: "Holnap reggel 7:00, 8:30 és 10:00-kor van szabad időpontod 60 perces személyi edzésre. Foglaljak valakinek?",
        aiAction: "AI azonnal megmutatja a szabad időpontokat",
      },
      marketing: {
        userMessage: "Csinálj egy email kampányt azoknak akik 2 hónapja nem edzettek nálam, kínálj nekik egy ingyenes edzést",
        aiResponse: "Találtam 28 inaktív ügyfelet. Email készült, benne az ingyenes visszatérő edzés kupon. Küldjük most vagy időzítsem holnap 9-re?",
        aiAction: "AI elkészíti a kampányt és célozza",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz edzőként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak edzéseket tarthatsz, hanem digitális termékeket, kurzusokat és tanácsadást is értékesíthetsz",
      products: [
        {
          emoji: "💪",
          title: "Edzések",
          description: "Az alapod - ügyfeleid online foglalhatnak időpontot minden edzésedre",
          items: [
            "Személyi edzés",
            "Csoportos funkcionális edzés",
            "Online edzés videóhívással",
            "Outdoor edzés",
          ],
        },
        {
          emoji: "📋",
          title: "Edzéstervek",
          description: "Magasabb árkategória - személyre szabott program",
          items: [
            "Egyéni edzésprogram összeállítás",
            "Étrend + edzésterv csomag",
            "Versenyre felkészítő program",
            "Rehabilitációs edzésterv",
          ],
        },
        {
          emoji: "👥",
          title: "Csoportos Programok",
          description: "Több embert érsz el egyszerre - magasabb bevétel, közösség építés",
          items: [
            "Bootcamp hétvége",
            "8 hetes átalakulás kihívás",
            "Nyári fitness tábor",
            "Csoportos reggeli edzések",
          ],
        },
        {
          emoji: "📚",
          title: "Digitális Termékek",
          description: "Passzív bevétel - egyszer készíted, folyamatosan értékesíted",
          items: [
            "Otthoni edzésprogram PDF",
            "Edzés videó csomag",
            "Táplálkozási útmutató",
            "Motivációs e-book",
          ],
        },
        {
          emoji: "🎫",
          title: "Bérletek és Tagságok",
          description: "Stabil, előre látható bevétel - lojális ügyfelek garantálva",
          items: [
            "10 alkalmas edzés bérlet",
            "Havi korlátlan tagság",
            "VIP éves program",
            "Ajándékutalványok",
          ],
        },
      ],
    },
  },
  yogaInstructors: {
    slug: "joga-oktato",
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Online · Mindig elérhető",
        inputPlaceholder: "Írj egy üzenetet...",
        user1: "Készíts nekem egy weboldalt jóga órákkal és órarenddel!",
        ai1: "Kész! Elkészítettem az oldaladat 3 szekcióval: hero, jóga órák és órarend. Itt az elérhetőséged: harmonyyoga.bespire.hu",
        user2: "Holnap 18:00-ra írd be Kovács Annát a Hatha jóga órára!",
        ai2: "Beírtam! Kovács Anna - Hatha Jóga, holnap 18:00. Értesítést is küldtem neki. 🧘",
        user3: "Küldj emailt azoknak akik 2 hónapja nem jártak órára!",
        ai3: "Elkészítettem a kampányt és kiküldtem 19 inaktív diáknak. Már 78%-os a megnyitási arány! 🙏",
        user4: "Köszi, ez fantasztikus! 😍",
        ai4: "Szívesen! Ha bármi kell, csak szólj. Weboldal, naptár, diákok, marketing - te csak taníts! 🧘‍♀️",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      domain: "harmonyyoga.bespire.hu",
      chatPrompt: "Építsd meg az oldalamat jóga órákkal és órarenddel!",
      aiMsg1: "Persze! Elkezdtem építeni az oldaladat. Néhány másodperc és kész is lesz...",
      aiMsg2: "Elkészültek a szekciók:",
      doneLabel: "Kész! Az oldalad él és elérhető:",
      userFollowUp: "Tudnád a színeket lila és fehér kombóra cserélni?",
      aiFollowUpReply: "Kész! Átállítottam a színeket lilára és fehérre. Gyönyörű lett! 🧘",
      blocks: {
        hero: "Hero szekció",
        services: "Jóga órák",
        pricing: "Órarend és árak",
      },
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      synced: "Szinkronizálva",
      freeLabel: "Szabad",
      userAsk: "Holnap mik a szabad helyek az órákon?",
      aiResponse: "Holnapi óráid és szabad helyek:",
      userBook: "Írd be Kovács Annát a 18:00-s Hatha órára!",
      aiConfirm: "Kész! Kovács Anna beírva a 18:00 Hatha jóga órára",
      notifSent: "Értesítés elküldve a diáknak",
      userThanks: "Köszönöm, szuper! 🙏",
      days: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      slots: {
        slot1: "Hatha jóga (8/12 fő)",
        slot2: "Vinyasa flow (6/10 fő)",
        slot3: "",
        slot4: "Yin jóga (10/10 fő)",
        slot5: "",
      },
      newBookingNotif: "Új jelentkezés: Tóth B. - Reggeli jóga 7:00",
    },
    clientsAnimation: {
      chatHeader: "Diák Kezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd meg Kovács Anna profilját!",
      userAction: "Küldj neki emlékeztetőt a lejáró bérletéről!",
      aiConfirm: "Kész! Emlékeztető elküldve Kovács Annának",
      visitsLabel: "alkalom",
      clients: {
        client1: { name: "Kovács Anna", tag: "Törzstag", status: "Aktív bérlet" },
        client2: { name: "Nagy Lilla", tag: "Új", status: "Próba óra" },
        client3: { name: "Szabó Eszter", tag: "VIP", status: "Korlátlan" },
        client4: { name: "Tóth Petra", tag: "Visszatérő", status: "10 alkalmas" },
      },
      tabs: {
        profile: "Profil",
        history: "Előzmények",
        notes: "Jegyzetek",
      },
      timeline: {
        firstVisit: "Első óra",
        passBought: "10 alkalmas bérlet",
        session: "Hatha jóga #8",
        renewal: "Bérlet megújítás",
      },
      stats: {
        retention: "Megtartás",
        vipClients: "Törzstag",
        growth: "Növekedés",
      },
    },
    marketingAnimation: {
      chatHeader: "Marketing",
      title: "Marketing automatizálás",
      subtitle: "AI asszisztens",
      userAsk: "Hozd vissza a 2 hónapja inaktív diákokat!",
      aiCampaignIntro: "Elkészítettem a kampányt! Íme az email előnézet:",
      emailSubject: "Hiányzol az óráinkról! 🧘",
      emailPreview: "Ingyenes visszatérő jóga óra kupon",
      emailCta: "Jelentkezem!",
      userSend: "Küldd ki most! 🚀",
      aiSentConfirm: "Kiküldtem mind a 19 címre!",
      userReply: "Ez fantasztikus! 😍",
      sentLabel: "Kiküldve",
      opensLabel: "Megnyitás",
      funnel: {
        audience: "Célközönség",
        audienceDetail: "19 inaktív diák",
        content: "Tartalom",
        contentDetail: "Visszatérő ajánlat email",
        sending: "Küldés",
        sendingDetail: "Kiküldve 19 címre",
        results: "Eredmények",
        resultsDetail: "78% megnyitás",
        resultTitle: "Kampány eredmény",
        live: "● Élő",
        conversions: "Visszatérő",
      },
    },
    teamAnimation: {
      chatHeader: "Csapatkezelés",
      chatSubheader: "AI asszisztens · Online",
      inputPlaceholder: "Írj egy üzenetet...",
      user1: "Mutasd a mai oktatókat! Ki tart ma órát?",
      ai1: "Íme a mai oktatók állapota:",
      user2: "Hogy állunk ma a jelentkezésekkel?",
      ai2: "Íme a mai statisztikák:",
      user3: "Tóth Lilla beteg, oszd szét az óráit a többiek között!",
      ai3: "Átszerveztem Tóth Lilla 4 óráját a szabad oktatókra.",
      user4: "Szuper, köszi! 🙏",
      ai4: "Szívesen! A diákokat is értesítettem az oktatóváltásról. Minden szinkronban van! 🧘",
      reassignDone: "4 óra átirányítva · 12 diák értesítve",
      statsBookings: "Mai jelentkezés",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Heti bevétel",
      staff: [
        { name: "Kovács Lilla", role: "Hatha oktató", status: "Elérhető" },
        { name: "Nagy Eszter", role: "Vinyasa oktató", status: "Órán" },
        { name: "Tóth Lilla", role: "Yin oktató", status: "Beteg" },
        { name: "Kiss Réka", role: "Reggeli jóga", status: "Elérhető" },
      ],
    },
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Solo jóga oktatóknak és több oktatós stúdióknak is.",
    heroImageAlt: "Jóga oktató órát tart",
    soloBadge: "Solo Jóga Oktatóknak",
    soloTitle: "Tökéletes egyéni jóga oktatóknak",
    soloDescription: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az órákat, a diákokat, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Több Oktatós Stúdióknak",
    teamTitle: "Komplex stúdió kezelés egyszerűen",
    teamDescription: "Ha több oktató dolgozik a stúdióban, a Bespire segít koordinálni a csapatot.",
    teamImageAlt: "Jóga stúdió csapat",
    phoneDemo: {
      businessName: "Harmony Yoga Studio",
      domain: "harmonyyoga.hu",
      serviceName: "Hatha Jóga",
      duration: "75 perc",
      price: "4.000 Ft",
      appointment: "Szerda, 18:00",
      therapist: "Lilla",
      appointmentLabel: "Időpont",
      therapistLabel: "Oktató",
      confirmButton: "Jelentkezés megerősítése",
      url: "harmonyyoga.hu/foglalas",
      tagline: "Jóga & Pilates órák minden szinten",
      selectService: "Válassz órát",
      services: [
        { name: "Hatha Jóga", duration: "75 perc", price: "4.000 Ft" },
        { name: "Vinyasa Flow", duration: "60 perc", price: "4.500 Ft" },
        { name: "Yin Jóga", duration: "90 perc", price: "5.000 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["07:00", "09:00", "10:30", "17:00", "18:30", "20:00"],
      confirmed: "Jelentkezés megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk SMS-ben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót a jóga órák típusaival és az órarenddel",
        aiResponse: "Rendben! Készítettem egy szekciót az óráknak. Hatha, Vinyasa, Yin jóga - mindegyikhez külön leírás és órarend. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza a jóga órák szekciót",
      },
      calendar: {
        userMessage: "Ma este mik a szabad helyek a Hatha jóga órán?",
        aiResponse: "Ma este 18:00-kor a Hatha jóga órán még 4 szabad hely van a 12-ből. Foglaljak valakit?",
        aiAction: "AI azonnal megmutatja a szabad helyeket",
      },
      marketing: {
        userMessage: "Csinálj egy email kampányt azoknak akik 2 hónapja nem jártak órára, kínálj nekik egy ingyenes órát",
        aiResponse: "Találtam 19 inaktív diákot. Email készült, benne az ingyenes visszatérő óra kupon. Küldjük most vagy időzítsem holnap 9-re?",
        aiAction: "AI elkészíti a kampányt és célozza",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz jóga oktatóként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak órákat tarthatsz, hanem digitális termékeket, kurzusokat és tanácsadást is értékesíthetsz",
      products: [
        {
          emoji: "🧘",
          title: "Jóga Órák",
          description: "Az alapod - diákjaid online jelentkezhetnek minden órádra",
          items: [
            "Hatha jóga kezdőknek",
            "Vinyasa flow haladóknak",
            "Yin jóga és meditáció",
            "Reggeli ébresztő jóga",
          ],
        },
        {
          emoji: "🙏",
          title: "Egyéni Konzultáció",
          description: "Magasabb árkategória - személyre szabott jóga tanácsadás",
          items: [
            "Egyéni jóga gyakorlat összeállítás",
            "Meditációs technikák tanítása",
            "Légzés és stresszkezelés",
            "Jóga életmód tanácsadás",
          ],
        },
        {
          emoji: "👥",
          title: "Workshopok és Elvonulások",
          description: "Mélyebb élmények - magasabb bevétel, közösség építés",
          items: [
            "Hétvégi jóga elvonulás",
            "Meditációs workshop",
            "Chakra workshop sorozat",
            "Nyári jóga tábor",
          ],
        },
        {
          emoji: "📚",
          title: "Digitális Termékek",
          description: "Passzív bevétel - egyszer készíted, folyamatosan értékesíted",
          items: [
            "Otthoni jóga rutin PDF",
            "Meditációs hanganyag csomag",
            "Jóga videó sorozat",
            "Légzőgyakorlatok útmutató",
          ],
        },
        {
          emoji: "🎫",
          title: "Bérletek és Tagságok",
          description: "Stabil, előre látható bevétel - lojális diákok garantálva",
          items: [
            "10 alkalmas jóga bérlet",
            "Havi korlátlan tagság",
            "VIP éves program",
            "Ajándékutalványok",
          ],
        },
      ],
    },
  },
  beauticians: {
    slug: "kozmetikus",
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Online · Mindig elérhető",
        inputPlaceholder: "Írj egy üzenetet...",
        user1: "Készíts nekem egy weboldalt kezelésekkel és árakkal!",
        ai1: "Kész! Elkészítettem az oldaladat 3 szekcióval: hero, kezelések és árlista. Itt az elérhetőséged: glowbeauty.bespire.hu",
        user2: "Holnap 10:00-ra foglalj be Kovács Annát hydrafacialra!",
        ai2: "Lefoglaltam! Kovács Anna - Hydrafacial, holnap 10:00. Értesítést is küldtem neki. ✨",
        user3: "Küldj emailt azoknak akik 3 hónapja nem jártak nálam!",
        ai3: "Elkészítettem a kampányt és kiküldtem 38 inaktív ügyfélnek. Már 88%-os a megnyitási arány!",
        user4: "Köszi, ez fantasztikus! 😍",
        ai4: "Szívesen! Ha bármi kell, csak szólj. Weboldal, naptár, ügyfelek, marketing - te csak szépítsd a világot! 💄",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      domain: "glowbeauty.bespire.hu",
      chatPrompt: "Építsd meg az oldalamat kezelésekkel és árakkal!",
      aiMsg1: "Persze! Elkezdtem építeni az oldaladat. Néhány másodperc és kész is lesz...",
      aiMsg2: "Elkészültek a szekciók:",
      doneLabel: "Kész! Az oldalad él és elérhető:",
      userFollowUp: "Tudnád a színeket rózsaszínre és aranyra cserélni?",
      aiFollowUpReply: "Kész! Átállítottam a színeket rózsaszínre és aranyra. Gyönyörű lett! 🌸",
      blocks: {
        hero: "Hero szekció",
        services: "Kezelések",
        pricing: "Árlista",
      },
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      synced: "Szinkronizálva",
      freeLabel: "Szabad",
      userAsk: "Holnap mik a szabad időpontjaim?",
      aiResponse: "Holnapi időpontjaid:",
      userBook: "Foglald le a 10:00-t Kovács Annának hydrafacialra!",
      aiConfirm: "Kész! 10:00 lefoglalva Kovács Annának - Hydrafacial",
      notifSent: "Értesítés elküldve az ügyfélnek",
      userThanks: "Köszönöm, szuper! ✨",
      days: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      slots: {
        slot1: "Nagy É. - Arctisztítás",
        slot2: "Szabó K. - Mezoterápia",
        slot3: "",
        slot4: "Kiss R. - Anti-aging",
        slot5: "",
      },
      newBookingNotif: "Új foglalás: Tóth A. - Hydrafacial 14:00",
    },
    clientsAnimation: {
      chatHeader: "Ügyfélkezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd meg Kiss Anna profilját!",
      userAction: "Küldj neki emlékeztetőt a lejáró kezelés csomagjáról!",
      aiConfirm: "Kész! Emlékeztető elküldve Kiss Annának",
      visitsLabel: "kezelés",
      clients: {
        client1: { name: "Kiss Anna", tag: "VIP", status: "Aktív csomag" },
        client2: { name: "Szabó Kata", tag: "Új", status: "Első kezelés" },
        client3: { name: "Nagy Réka", tag: "VIP", status: "Éves tagság" },
        client4: { name: "Tóth Zsófi", tag: "Visszatérő", status: "Havi program" },
      },
      tabs: {
        profile: "Profil",
        history: "Előzmények",
        notes: "Jegyzetek",
      },
      timeline: {
        firstVisit: "Első kezelés",
        passBought: "5 alkalmas csomag",
        session: "Hydrafacial #4",
        renewal: "Csomag megújítás",
      },
      stats: {
        retention: "Megtartás",
        vipClients: "VIP ügyfél",
        growth: "Növekedés",
      },
    },
    marketingAnimation: {
      chatHeader: "Marketing",
      title: "Marketing automatizálás",
      subtitle: "AI asszisztens",
      userAsk: "Hozd vissza a 3 hónapja inaktív ügyfeleket!",
      aiCampaignIntro: "Elkészítettem a kampányt! Íme az email előnézet:",
      emailSubject: "Hiányzol nekünk! ✨",
      emailPreview: "25% kedvezmény az első visszatérő kezelésre",
      emailCta: "Foglalok!",
      userSend: "Küldd ki most! 🚀",
      aiSentConfirm: "Kiküldtem mind a 38 címre!",
      userReply: "Ez fantasztikus! 😍",
      sentLabel: "Kiküldve",
      opensLabel: "Megnyitás",
      funnel: {
        audience: "Célközönség",
        audienceDetail: "38 inaktív ügyfél",
        content: "Tartalom",
        contentDetail: "Visszatérő kedvezmény email",
        sending: "Küldés",
        sendingDetail: "Kiküldve 38 címre",
        results: "Eredmények",
        resultsDetail: "88% megnyitás",
        resultTitle: "Kampány eredmény",
        live: "● Élő",
        conversions: "Visszatérő",
      },
    },
    teamAnimation: {
      chatHeader: "Csapatkezelés",
      chatSubheader: "AI asszisztens · Online",
      inputPlaceholder: "Írj egy üzenetet...",
      user1: "Mutasd a mai csapatot! Ki dolgozik ma?",
      ai1: "Íme a mai csapat állapota:",
      user2: "Hogy állunk ma a foglalásokkal?",
      ai2: "Íme a mai statisztikák:",
      user3: "Nagy Zsófi beteg lett, oszd szét a kezeléseit a többiek között!",
      ai3: "Átszerveztem Nagy Zsófi 4 kezelését a szabad kozmetikusokra.",
      user4: "Szuper, köszi! 🙌",
      ai4: "Szívesen! Az ügyfeleket is értesítettem a kozmetikus váltásról. Minden szinkronban van! ✨",
      reassignDone: "4 kezelés átirányítva · 4 ügyfél értesítve",
      statsBookings: "Mai foglalás",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Heti bevétel",
      staff: [
        { name: "Kovács Zsófi", role: "Senior kozmetikus", status: "Elérhető" },
        { name: "Nagy Anna", role: "Hydrafacial szakértő", status: "Kezelésen" },
        { name: "Kiss Réka", role: "Anti-aging kozmetikus", status: "Beteg" },
        { name: "Tóth Lili", role: "Sminktetováló", status: "Elérhető" },
      ],
    },
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Solo kozmetikusoknak és több szakemberes szalonoknak is.",
    heroImageAlt: "Kozmetikus kezelést végez",
    soloBadge: "Solo Kozmetikusoknak",
    soloTitle: "Tökéletes egyéni kozmetikusoknak",
    soloDescription: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az időpontokat, az ügyfeleket, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Több Szakemberes Szalonoknak",
    teamTitle: "Komplex szépségszalon kezelés egyszerűen",
    teamDescription: "Ha több szakember dolgozik a szalonban, a Bespire segít koordinálni a csapatot.",
    teamImageAlt: "Szépségszalon csapat együttműködés",
    phoneDemo: {
      businessName: "Glow Beauty Szalon",
      domain: "glowbeauty.hu",
      serviceName: "Hydrafacial kezelés",
      duration: "60 perc",
      price: "18.000 Ft",
      appointment: "Csütörtök, 10:00",
      therapist: "Zsófi",
      appointmentLabel: "Időpont",
      therapistLabel: "Kozmetikus",
      confirmButton: "Foglalás megerősítése",
      url: "glowbeauty.hu/foglalas",
      tagline: "Professzionális kozmetikai kezelések",
      selectService: "Válassz kezelést",
      services: [
        { name: "Hydrafacial", duration: "60 perc", price: "18.000 Ft" },
        { name: "Arctisztítás", duration: "45 perc", price: "12.000 Ft" },
        { name: "Anti-aging kezelés", duration: "90 perc", price: "25.000 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["09:00", "10:30", "12:00", "14:00", "16:00", "18:00"],
      confirmed: "Foglalás megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk SMS-ben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót a kezelések típusaival és az árakkal",
        aiResponse: "Rendben! Készítettem egy szekciót a kezeléseknek. Arctisztítás, hydrafacial, anti-aging - mindegyikhez külön leírás. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza a kezelések szekciót",
      },
      calendar: {
        userMessage: "Holnap délelőtt mik a szabad időpontjaim hydrafacialra?",
        aiResponse: "Holnap délelőtt 9:00, 10:30 és 12:00-kor van szabad időpontod 60 perces hydrafacialra. Foglaljak valakinek?",
        aiAction: "AI azonnal megmutatja a szabad időpontokat",
      },
      marketing: {
        userMessage: "Csinálj egy email kampányt azoknak akik 3 hónapja nem jártak nálam, kínálj nekik 25% kedvezményt az első kezelésre",
        aiResponse: "Találtam 38 inaktív ügyfelet. Email készült, benne a 25% kedvezmény kupon. Küldjük most vagy időzítsem holnap 9-re?",
        aiAction: "AI elkészíti a kampányt és célozza",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz kozmetikusként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak kezeléseket tarthatsz, hanem digitális termékeket, kurzusokat és tanácsadást is értékesíthetsz",
      products: [
        {
          emoji: "✨",
          title: "Kozmetikai Kezelések",
          description: "Az alapod - ügyfeleid online foglalhatnak időpontot minden kezelésedre",
          items: [
            "Arctisztítás, hidratálás",
            "Hydrafacial, mezoterápia",
            "Anti-aging kezelések",
            "Gyógykozmetika",
          ],
        },
        {
          emoji: "💄",
          title: "Bőrápolási Tanácsadás",
          description: "Magasabb árkategória - személyre szabott bőrápolási rutin",
          items: [
            "Bőrtípus elemzés és tanácsadás",
            "Otthoni ápolási rutin összeállítás",
            "Termék ajánlások",
            "Évszakos bőrápolási terv",
          ],
        },
        {
          emoji: "👥",
          title: "Szépség Workshopok",
          description: "Több embert érsz el egyszerre - magasabb bevétel, közösség építés",
          items: [
            "Sminkes masterclass",
            "Otthoni ápolás workshop",
            "Lánybúcsú szépségnap",
            "Szezonális bőrápolás tanfolyam",
          ],
        },
        {
          emoji: "📚",
          title: "Digitális Termékek",
          description: "Passzív bevétel - egyszer készíted, folyamatosan értékesíted",
          items: [
            "Bőrápolási útmutató PDF",
            "Sminkes videó csomag",
            "Otthoni SPA rutin e-book",
            "Termék értékelések katalógus",
          ],
        },
        {
          emoji: "🎫",
          title: "Kezelés Csomagok",
          description: "Stabil, előre látható bevétel - lojális ügyfelek garantálva",
          items: [
            "5 alkalmas kezelés csomag",
            "Havi szépség program",
            "VIP éves tagság",
            "Ajándékutalványok",
          ],
        },
      ],
    },
  },
  consultants: {
    slug: "tanacsado",
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Solo tanácsadóknak és több szakemberes cégeknek is.",
    heroImageAlt: "Tanácsadó konzultációt tart",
    soloBadge: "Solo Tanácsadóknak",
    soloTitle: "Tökéletes egyéni tanácsadóknak",
    soloDescription: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az időpontokat, az ügyfeleket, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Több Tanácsadós Cégeknek",
    teamTitle: "Komplex tanácsadó cég kezelés egyszerűen",
    teamDescription: "Ha több tanácsadó dolgozik a csapatban, a Bespire segít koordinálni a munkát.",
    teamImageAlt: "Tanácsadó csapat együttműködés",
    phoneDemo: {
      businessName: "Growth Consulting",
      domain: "growthconsulting.hu",
      serviceName: "Stratégiai konzultáció",
      duration: "90 perc",
      price: "50.000 Ft",
      appointment: "Kedd, 10:00",
      therapist: "Balázs",
      appointmentLabel: "Időpont",
      therapistLabel: "Tanácsadó",
      confirmButton: "Foglalás megerősítése",
      url: "growthconsulting.hu/foglalas",
      tagline: "Üzleti tanácsadás & coaching",
      selectService: "Válassz szolgáltatást",
      services: [
        { name: "Stratégiai konzultáció", duration: "90 perc", price: "50.000 Ft" },
        { name: "Business coaching", duration: "60 perc", price: "35.000 Ft" },
        { name: "Workshop", duration: "3 óra", price: "120.000 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["09:00", "10:30", "13:00", "14:30", "16:00", "17:30"],
      confirmed: "Foglalás megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk e-mailben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót a szolgáltatásaimmal és az árakkal",
        aiResponse: "Rendben! Készítettem egy szekciót a szolgáltatásoknak. Stratégiai konzultáció, coaching csomag, workshop - mindegyikhez külön leírás. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza a szolgáltatások szekciót",
      },
      calendar: {
        userMessage: "Jövő héten mik a szabad időpontjaim stratégiai konzultációra?",
        aiResponse: "Jövő héten kedden 10:00, szerdán 14:00 és pénteken 9:00-kor van szabad időpontod 90 perces stratégiai konzultációra. Foglaljak valakinek?",
        aiAction: "AI azonnal megmutatja a szabad időpontokat",
      },
      marketing: {
        userMessage: "Csinálj egy email kampányt azoknak akik korábban érdeklődtek de nem foglaltak, kínálj nekik egy ingyenes 30 perces bevezető hívást",
        aiResponse: "Találtam 24 potenciális ügyfelet. Email készült, benne az ingyenes bevezető hívás ajánlat. Küldjük most vagy időzítsem holnap 9-re?",
        aiAction: "AI elkészíti a kampányt és célozza",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz tanácsadóként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak konzultációkat tarthatsz, hanem digitális termékeket, kurzusokat és workshopokat is értékesíthetsz",
      products: [
        {
          emoji: "💼",
          title: "Konzultációk",
          description: "Az alapod - ügyfeleid online foglalhatnak időpontot minden konzultációdra",
          items: [
            "Egyéni stratégiai konzultáció",
            "Üzleti elemzés és javaslatok",
            "Probléma-megoldó session",
            "Follow-up és támogatás",
          ],
        },
        {
          emoji: "🎯",
          title: "Coaching Programok",
          description: "Magasabb árkategória - hosszú távú együttműködés",
          items: [
            "3 hónapos coaching csomag",
            "Éves mentoring program",
            "VIP intenzív hétvége",
            "Mastermind csoport",
          ],
        },
        {
          emoji: "👥",
          title: "Workshopok és Tréningek",
          description: "Több embert érsz el egyszerre - magasabb bevétel, közösség építés",
          items: [
            "Céges képzések",
            "Nyilvános workshop",
            "Online webinárium",
            "Konferencia előadás",
          ],
        },
        {
          emoji: "📚",
          title: "Digitális Termékek",
          description: "Passzív bevétel - egyszer készíted, folyamatosan értékesíted",
          items: [
            "Stratégiai útmutató PDF",
            "Online kurzus csomag",
            "Sablonok és eszközök",
            "E-book és munkafüzet",
          ],
        },
        {
          emoji: "🎫",
          title: "Retainer Csomagok",
          description: "Stabil, előre látható bevétel - lojális ügyfelek garantálva",
          items: [
            "Havi tanácsadói retainer",
            "Negyedéves stratégiai csomag",
            "Éves VIP szolgáltatás",
            "Folyamatos támogatás",
          ],
        },
      ],
    },
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Tanácsadó Asszisztens · Online",
        user1: "Építs nekem egy professzionális tanácsadó weboldalt!",
        ai1: "Máris! Készítek egy elegáns oldalt a szolgáltatásaiddal, ügyfélvéleményekkel és foglalási lehetőséggel.",
        user2: "Állítsd be a naptáram, hogy kedden és csütörtökön fogadjak ügyfeleket.",
        ai2: "Kész! Kedd és csütörtök beállítva konzultációs napoknak. Az ügyfelek online foglalhatnak.",
        user3: "Küldj egy emlékeztető emailt a holnapi ügyfeleknek.",
        ai3: "Elküldtem! 3 ügyfélnek ment emlékeztető a holnapi konzultációról, időponttal és helyszínnel.",
        user4: "Szuper, köszönöm!",
        ai4: "Nincs mit! Ha bármire szükséged van, szólj! 💼",
        inputPlaceholder: "Írj egy üzenetet...",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      chatPrompt: "Építs egy profi tanácsadó weboldalt, legyen rajta szolgáltatások szekció és foglalási lehetőség!",
      aiMsg1: "Remek! Elemzem a tanácsadó profilt és elkészítem a tökéletes weboldalt...",
      aiMsg2: "A következő szekciókat készítettem el:",
      blocks: {
        hero: "Bemutatkozás és szakértelem",
        services: "Szolgáltatások és árak",
        pricing: "Foglalási rendszer + vélemények",
      },
      doneLabel: "A weboldalad kész! Nézd meg itt:",
      domain: "growthconsulting.hu",
      userFollowUp: "Adj hozzá egy blog szekciót is!",
      aiFollowUpReply: "Kész! Blog szekció hozzáadva, ahol szakmai cikkeket publikálhatsz. Szeretnél még módosítani?",
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      userAsk: "Mutasd a holnapi programomat konzultációkra!",
      aiResponse: "Holnapi naptár - Kedd, Március 10:",
      slots: {
        slot1: "Nagy P. - Stratégia",
        slot2: "Tech Startup - Üzleti terv",
        slot4: "Kovács Kft. - Follow-up",
      },
      freeLabel: "Szabad",
      userBook: "Foglald le a 14:30-as időpontot Tóth Annának coaching sessionre!",
      aiConfirm: "Foglalva! Tóth Anna - Coaching, 14:30. Megerősítő email elküldve.",
      notifSent: "Emlékeztető kiküldve az ügyfélnek",
      userThanks: "Szuper, köszi!",
      newBookingNotif: "Új foglalás érkezett: Tóth A. - Coaching 14:30",
    },
    clientsAnimation: {
      chatHeader: "Ügyfélkezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd Nagy Péter ügyfél adatlapját!",
      clients: {
        client1: {
          name: "Nagy Péter",
          tag: "VIP Ügyfél",
          status: "Aktív coaching program",
        },
      },
      visitsLabel: "konzultáció",
      timeline: {
        firstMeeting: "Első konzultáció",
        strategyBought: "Coaching csomag",
        lastSession: "Utolsó session",
        renewal: "Csomag megújítás",
      },
      userAction: "Küldj neki egy személyes ajánlatot a Q2 stratégiai csomagra!",
      aiConfirm: "Személyes ajánlat elküldve! A Q2 stratégiai csomag részletei és kedvezményes ár benne van.",
      stats: {
        retention: "Megtartás",
        vipClients: "VIP ügyfelek",
        growth: "Növekedés",
      },
    },
    teamAnimation: {
      chatHeader: "Csapatkezelés",
      chatSubheader: "AI asszisztens · Online",
      user1: "Mutasd a tanácsadó csapat mai státuszát!",
      ai1: "Íme a csapatod mai áttekintése:",
      staff: [
        { name: "Kiss Balázs", role: "Senior Tanácsadó", status: "Elérhető" },
        { name: "Szabó Anna", role: "Business Coach", status: "Konzultáción" },
        { name: "Tóth Márk", role: "Junior Tanácsadó", status: "Szabadnapos" },
        { name: "Varga Lili", role: "Workshop Vezető", status: "Elérhető" },
      ],
      user2: "Mi a mai foglaltság és bevétel?",
      ai2: "Mai összefoglaló:",
      statsBookings: "Konzultáció",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Bevétel",
      user3: "Tóth Márk holnapi ügyfeleit oszd át Kiss Balázsnak!",
      ai3: "Átszervezem a holnapi beosztást...",
      reassignDone: "3 konzultáció átütemezve Kiss Balázshoz. Ügyfelek értesítve.",
      user4: "Köszönöm!",
      ai4: "Szívesen! A csapat hatékonyan működik. Ha kell még valami, szólj! 💼",
      inputPlaceholder: "Kérdezz a csapatodról...",
    },
  },
  photographers: {
    slug: "fotos",
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Online · Mindig elérhető",
        inputPlaceholder: "Írj egy üzenetet...",
        user1: "Készíts nekem egy portfólió weboldalt a munkáimmal!",
        ai1: "Kész! Elkészítettem az oldaladat 3 szekcióval: hero, galéria és árlista. Itt az elérhetőséged: capture-daniel.bespire.hu",
        user2: "Szombatra foglalj be egy esküvői fotózást Kovács Annáéknak!",
        ai2: "Lefoglaltam! Kovács Anna - Esküvői fotózás, szombat egész nap. Értesítést is küldtem nekik. 📸",
        user3: "Küldj emailt azoknak akik tavaly kisbaba fotózáson voltak!",
        ai3: "Elkészítettem a kampányt és kiküldtem 42 ügyfélnek. Már 85%-os a megnyitási arány!",
        user4: "Köszi, ez fantasztikus! 😍",
        ai4: "Szívesen! Ha bármi kell, csak szólj. Weboldal, naptár, ügyfelek, marketing - te csak fotózz! 📷",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      domain: "capture-daniel.bespire.hu",
      chatPrompt: "Építsd meg a portfólió oldalamat galériával és árakkal!",
      aiMsg1: "Persze! Elkezdtem építeni az oldaladat. Néhány másodperc és kész is lesz...",
      aiMsg2: "Elkészültek a szekciók:",
      doneLabel: "Kész! Az oldalad él és elérhető:",
      userFollowUp: "Tudnád a színeket sötétszürkére és aranyra cserélni?",
      aiFollowUpReply: "Kész! Átállítottam a színeket sötétszürkére és aranyra. Elegáns lett! 🎨",
      blocks: {
        hero: "Hero szekció",
        services: "Fotózás típusok",
        pricing: "Árlista és csomagok",
      },
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      synced: "Szinkronizálva",
      freeLabel: "Szabad",
      userAsk: "Jövő héten mik a szabad időpontjaim?",
      aiResponse: "Jövő heti időpontjaid:",
      userBook: "Foglald le a 11:00-t Nagy Évának portré fotózásra!",
      aiConfirm: "Kész! 11:00 lefoglalva Nagy Évának - Portré fotózás",
      notifSent: "Értesítés elküldve az ügyfélnek",
      userThanks: "Köszönöm, szuper! 📸",
      days: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      slots: {
        slot1: "Kovács A. - Esküvő",
        slot2: "Céges headshot (6 fő)",
        slot3: "",
        slot4: "Családi fotózás",
        slot5: "",
      },
      newBookingNotif: "Új foglalás érkezett: Szabó K. - Kismama 15:00",
    },
    clientsAnimation: {
      chatHeader: "Ügyfélkezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd meg Nagy Anna profilját!",
      userAction: "Küldj neki ajánlatot az évfordulós fotózásra!",
      aiConfirm: "Kész! Ajánlat elküldve Nagy Annának",
      visitsLabel: "fotózás",
      clients: {
        client1: { name: "Nagy Anna", tag: "VIP", status: "Visszatérő ügyfél" },
        client2: { name: "Szabó Dávid", tag: "Új", status: "Portré fotózás" },
        client3: { name: "Kiss Réka", tag: "VIP", status: "Éves csomag" },
        client4: { name: "Tóth Péter", tag: "Céges", status: "Retainer" },
      },
      tabs: {
        profile: "Profil",
        history: "Előzmények",
        notes: "Jegyzetek",
      },
      timeline: {
        firstVisit: "Első fotózás",
        passBought: "Éves csomag",
        session: "Kismama fotózás",
        renewal: "Kisgyerek fotózás",
      },
      stats: {
        retention: "Visszatérés",
        vipClients: "VIP ügyfél",
        growth: "Növekedés",
      },
    },
    marketingAnimation: {
      chatHeader: "Marketing",
      title: "Marketing automatizálás",
      subtitle: "AI asszisztens",
      userAsk: "Hozd vissza a tavaly kisbaba fotózáson járt ügyfeleket!",
      aiCampaignIntro: "Elkészítettem a kampányt! Íme az email előnézet:",
      emailSubject: "Nőtt a kicsi! 👶→🧒",
      emailPreview: "Kisgyerek fotózás kedvezménnyel",
      emailCta: "Foglalok!",
      userSend: "Küldd ki most! 🚀",
      aiSentConfirm: "Kiküldtem mind a 42 címre!",
      userReply: "Ez fantasztikus! 😍",
      sentLabel: "Kiküldve",
      opensLabel: "Megnyitás",
      funnel: {
        audience: "Célközönség",
        audienceDetail: "42 kisbaba fotós ügyfél",
        content: "Tartalom",
        contentDetail: "Kisgyerek fotó ajánlat",
        sending: "Küldés",
        sendingDetail: "Kiküldve 42 címre",
        results: "Eredmények",
        resultsDetail: "85% megnyitás",
        resultTitle: "Kampány eredmény",
        live: "● Élő",
        conversions: "Visszatérő",
      },
    },
    teamAnimation: {
      chatHeader: "Csapatkezelés",
      chatSubheader: "AI asszisztens · Online",
      inputPlaceholder: "Írj egy üzenetet...",
      user1: "Mutasd a mai csapatot! Ki dolgozik ma?",
      ai1: "Íme a mai csapat állapota:",
      user2: "Hogy állunk a heti foglalásokkal?",
      ai2: "Íme a heti statisztikák:",
      user3: "Kiss Márk beteg lett, oszd szét a mai fotózásait!",
      ai3: "Átszerveztem Kiss Márk 3 fotózását a szabad fotósokra.",
      user4: "Szuper, köszi! 🙌",
      ai4: "Szívesen! Az ügyfeleket is értesítettem a fotósváltásról. Minden szinkronban van! 📸",
      reassignDone: "3 fotózás átirányítva · 3 ügyfél értesítve",
      statsBookings: "Heti foglalás",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Havi bevétel",
      staff: [
        { name: "Kovács Dániel", role: "Senior fotós", status: "Elérhető" },
        { name: "Nagy Bence", role: "Esküvői fotós", status: "Fotózáson" },
        { name: "Kiss Márk", role: "Portré fotós", status: "Beteg" },
        { name: "Tóth Anna", role: "Rendezvény fotós", status: "Elérhető" },
      ],
    },
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Solo fotósoknak és több fotós stúdióknak is.",
    heroImageAlt: "Fotós fotózást végez",
    soloBadge: "Solo Fotósoknak",
    soloTitle: "Tökéletes egyéni fotósoknak",
    soloDescription: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az időpontokat, az ügyfeleket, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Több Fotós Stúdióknak",
    teamTitle: "Komplex stúdió kezelés egyszerűen",
    teamDescription: "Ha több fotós dolgozik a stúdióban, a Bespire segít koordinálni a csapatot.",
    teamImageAlt: "Fotó stúdió csapat együttműködés",
    phoneDemo: {
      businessName: "Capture Studio",
      domain: "capturestudio.hu",
      serviceName: "Portré fotózás",
      duration: "2 óra",
      price: "45.000 Ft",
      appointment: "Szombat, 14:00",
      therapist: "Dániel",
      appointmentLabel: "Időpont",
      therapistLabel: "Fotós",
      confirmButton: "Foglalás megerősítése",
      url: "capturestudio.hu/foglalas",
      tagline: "Professzionális fotó & videó szolgáltatások",
      selectService: "Válassz szolgáltatást",
      services: [
        { name: "Portré fotózás", duration: "2 óra", price: "45.000 Ft" },
        { name: "Esküvői fotózás", duration: "8 óra", price: "250.000 Ft" },
        { name: "Céges fotózás", duration: "4 óra", price: "120.000 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["09:00", "11:00", "13:00", "15:00", "17:00", "19:00"],
      confirmed: "Foglalás megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk e-mailben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót a fotózás típusokkal és az árakkal",
        aiResponse: "Rendben! Készítettem egy szekciót a szolgáltatásoknak. Portré, esküvő, céges fotózás - mindegyikhez külön leírás és galéria. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza a fotózások szekciót",
      },
      calendar: {
        userMessage: "Jövő héten mik a szabad időpontjaim esküvői fotózásra?",
        aiResponse: "Jövő héten szombaton és vasárnap egész nap szabad vagyok esküvői fotózásra. Pénteken délután is elérhető vagyok. Foglaljak valamelyiket?",
        aiAction: "AI azonnal megmutatja a szabad időpontokat",
      },
      marketing: {
        userMessage: "Csinálj egy email kampányt azoknak akik tavaly kisbaba fotózáson voltak, most lehet hogy kisgyerek fotót szeretnének",
        aiResponse: "Találtam 42 ügyfelet akik 1 éve kisbaba fotózáson voltak. Email készült személyre szabott üzenettel. Küldjük most vagy időzítsem?",
        aiAction: "AI elkészíti a kampányt és célozza",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz fotósként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak fotózásokat tarthatsz, hanem digitális termékeket, kurzusokat és tanácsadást is értékesíthetsz",
      products: [
        {
          emoji: "📸",
          title: "Fotózások",
          description: "Az alapod - ügyfeleid online foglalhatnak időpontot minden fotózásodra",
          items: [
            "Portré és üzleti fotózás",
            "Esküvői fotózás",
            "Családi és kismama fotózás",
            "Rendezvény és céges fotózás",
          ],
        },
        {
          emoji: "🖼️",
          title: "Termékek és Nyomatok",
          description: "Magasabb árkategória - prémium termékek",
          items: [
            "Nyomtatott fotóalbum",
            "Vászonkép és keretezett nyomat",
            "Akril és fémnyomat",
            "Digitális képcsomag",
          ],
        },
        {
          emoji: "👥",
          title: "Workshopok",
          description: "Több embert érsz el egyszerre - magasabb bevétel, közösség építés",
          items: [
            "Fotós alapok workshop",
            "Lightroom szerkesztés tanfolyam",
            "Portré fotózás masterclass",
            "Mobil fotózás tippek",
          ],
        },
        {
          emoji: "📚",
          title: "Digitális Termékek",
          description: "Passzív bevétel - egyszer készíted, folyamatosan értékesíted",
          items: [
            "Lightroom preset csomag",
            "Fotós útmutató kezdőknek",
            "Pózolási tippek e-book",
            "Utómunka videó kurzus",
          ],
        },
        {
          emoji: "🎫",
          title: "Csomagok és Előfizetés",
          description: "Stabil, előre látható bevétel - lojális ügyfelek garantálva",
          items: [
            "Éves családi fotó csomag",
            "Céges fotó retainer",
            "Havi content fotózás",
            "Ajándékutalványok",
          ],
        },
      ],
    },
  },
  nailTechnicians: {
    slug: "kormos",
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Online · Mindig elérhető",
        inputPlaceholder: "Írj egy üzenetet...",
        user1: "Készíts nekem egy weboldalt köröm szolgáltatásokkal és árakkal!",
        ai1: "Kész! Elkészítettem az oldaladat 3 szekcióval: hero, szolgáltatások és árlista. Itt az elérhetőséged: nailsbeauty.bespire.hu",
        user2: "Holnap 16:00-ra foglalj be Szabó Lilát gél lakkra!",
        ai2: "Lefoglaltam! Szabó Lila - Gél lakk, holnap 16:00. Értesítést is küldtem neki.",
        user3: "Küldj emailt azoknak akik 2 hónapja nem jártak nálam!",
        ai3: "Elkészítettem a kampányt és kiküldtem 24 inaktív ügyfélnek. Már 88%-os a megnyitási arány!",
        user4: "Köszi, ez fantasztikus! 😍",
        ai4: "Szívesen! Ha bármi kell, csak szólj. Weboldal, naptár, ügyfelek, marketing - te csak körmözz! 💅",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      domain: "nailsbeauty.bespire.hu",
      chatPrompt: "Építsd meg az oldalamat köröm szolgáltatásokkal és árakkal!",
      aiMsg1: "Persze! Elkezdtem építeni az oldaladat. Néhány másodperc és kész is lesz...",
      aiMsg2: "Elkészültek a szekciók:",
      doneLabel: "Kész! Az oldalad él és elérhető:",
      userFollowUp: "Tudnád a színeket pink és lila kombóra cserélni?",
      aiFollowUpReply: "Kész! Átállítottam a színeket pinkre és lilára. Gyönyörű lett! 💅",
      blocks: {
        hero: "Hero szekció",
        services: "Köröm szolgáltatások",
        pricing: "Árlista",
      },
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      synced: "Szinkronizálva",
      freeLabel: "Szabad",
      userAsk: "Holnap mik a szabad időpontjaim?",
      aiResponse: "Holnapi időpontjaid:",
      userBook: "Foglald le a 10:30-at Szabó Lilának gél lakkra!",
      aiConfirm: "Kész! 10:30 lefoglalva Szabó Lilának - Gél lakk",
      notifSent: "Értesítés elküldve az ügyfélnek",
      userThanks: "Köszönöm, szuper! 👍",
      days: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      slots: {
        slot1: "Kiss A. - Gél lakk",
        slot2: "Nagy E. - Műköröm építés",
        slot3: "",
        slot4: "Tóth L. - Díszítés",
        slot5: "",
      },
      newBookingNotif: "Új foglalás érkezett: Kovács B. - Manikűr 15:00",
    },
    clientsAnimation: {
      chatHeader: "Ügyfélkezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd meg Szabó Lila profilját!",
      userAction: "Küldj neki emlékeztetőt a lejáró bérletéről!",
      aiConfirm: "Kész! Emlékeztető elküldve Szabó Lilának",
      visitsLabel: "alkalom",
      clients: {
        client1: { name: "Szabó Lila", tag: "VIP", status: "Aktív bérlet" },
        client2: { name: "Kiss Anna", tag: "Új", status: "Első manikűr" },
        client3: { name: "Nagy Eszter", tag: "VIP", status: "8 alkalmas" },
        client4: { name: "Tóth Laura", tag: "Visszatérő", status: "Havi bérlet" },
      },
      tabs: {
        profile: "Profil",
        history: "Előzmények",
        notes: "Jegyzetek",
      },
      timeline: {
        firstVisit: "Első látogatás",
        passBought: "8 alkalmas bérlet",
        session: "Gél lakk #6",
        renewal: "Bérlet megújítás",
      },
      stats: {
        retention: "Megtartás",
        vipClients: "VIP ügyfél",
        growth: "Növekedés",
      },
    },
    marketingAnimation: {
      chatHeader: "Marketing",
      title: "Marketing automatizálás",
      subtitle: "AI asszisztens",
      userAsk: "Hozd vissza a 2 hónapja inaktív ügyfeleket!",
      aiCampaignIntro: "Elkészítettem a kampányt! Íme az email előnézet:",
      emailSubject: "Hiányzol nekünk!",
      emailPreview: "15% kedvezmény visszatérő ügyfeleknek",
      emailCta: "Foglalok!",
      userSend: "Küldd ki most! 🚀",
      aiSentConfirm: "Kiküldtem mind a 24 címre!",
      userReply: "Ez fantasztikus! 😍",
      sentLabel: "Kiküldve",
      opensLabel: "Megnyitás",
      funnel: {
        audience: "Célközönség",
        audienceDetail: "24 inaktív ügyfél",
        content: "Tartalom",
        contentDetail: "Visszatérő ajánlat email",
        sending: "Küldés",
        sendingDetail: "Kiküldve 24 címre",
        results: "Eredmények",
        resultsDetail: "88% megnyitás",
        resultTitle: "Kampány eredmény",
        live: "● Élő",
        conversions: "Visszatérő",
      },
    },
    teamAnimation: {
      chatHeader: "Csapatkezelés",
      chatSubheader: "AI asszisztens · Online",
      inputPlaceholder: "Írj egy üzenetet...",
      user1: "Mutasd a mai csapatot! Ki dolgozik ma?",
      ai1: "Íme a mai csapat állapota:",
      user2: "Hogy állunk ma a foglalásokkal?",
      ai2: "Íme a mai statisztikák:",
      user3: "Horváth Réka beteg, oszd szét az ügyfeleit a többiek között!",
      ai3: "Átszerveztem Horváth Réka 5 ügyfelét a szabad körmösökre.",
      user4: "Szuper, köszi! 🙌",
      ai4: "Szívesen! Az ügyfeleket is értesítettem a körmösváltásról. Minden szinkronban van! 💅",
      reassignDone: "5 ügyfél átirányítva · 5 ügyfél értesítve",
      statsBookings: "Mai foglalás",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Heti bevétel",
      staff: [
        { name: "Kiss Petra", role: "Senior körmös", status: "Elérhető" },
        { name: "Nagy Zsófi", role: "Műkörömépítő", status: "Ügyfélnél" },
        { name: "Horváth Réka", role: "Gél lakk spec.", status: "Beteg" },
        { name: "Tóth Bea", role: "Díszítő művész", status: "Elérhető" },
      ],
    },
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Solo körmösöknek és több körmös szalonoknak is.",
    heroImageAlt: "Körmös manikűrt készít",
    soloBadge: "Solo Körmösöknek",
    soloTitle: "Tökéletes egyéni műkörömépítőknek",
    soloDescription: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az időpontokat, az ügyfeleket, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Több Körmös Szalonoknak",
    teamTitle: "Komplex szalon kezelés egyszerűen",
    teamDescription: "Ha több körmös dolgozik a szalonban, a Bespire segít koordinálni a csapatot.",
    teamImageAlt: "Körmös szalon csapat együttműködés",
    phoneDemo: {
      businessName: "Nails & Beauty",
      domain: "nailsbeauty.hu",
      serviceName: "Gél lakk",
      duration: "60 perc",
      price: "8.000 Ft",
      appointment: "Péntek, 16:00",
      therapist: "Réka",
      appointmentLabel: "Időpont",
      therapistLabel: "Körmös",
      confirmButton: "Foglalás megerősítése",
      url: "nailsbeauty.hu/foglalas",
      tagline: "Professzionális köröm szolgáltatások",
      selectService: "Válassz szolgáltatást",
      services: [
        { name: "Gél lakk", duration: "60 perc", price: "8.000 Ft" },
        { name: "Műköröm építés", duration: "90 perc", price: "12.000 Ft" },
        { name: "Köröm díszítés", duration: "30 perc", price: "5.000 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["09:00", "10:30", "12:00", "14:00", "16:00", "18:00"],
      confirmed: "Foglalás megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk SMS-ben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót a köröm szolgáltatásokkal és az árakkal",
        aiResponse: "Rendben! Készítettem egy szekciót a szolgáltatásoknak. Gél lakk, műköröm, díszítések - mindegyikhez külön leírás és galéria. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza a szolgáltatások szekciót",
      },
      calendar: {
        userMessage: "Holnap délután mik a szabad időpontjaim műköröm építésre?",
        aiResponse: "Holnap délután 13:00, 15:30 és 18:00-kor van szabad időpontod 90 perces műköröm építésre. Foglaljak valakinek?",
        aiAction: "AI azonnal megmutatja a szabad időpontokat",
      },
      marketing: {
        userMessage: "Csinálj egy Instagram posztot a legújabb tavaszi köröm mintáimmal",
        aiResponse: "Készítettem egy posztot a galériádból a tavaszi mintákkal. Hashtag-ek hozzáadva, leírás készen. Publikáljam most vagy időzítsem?",
        aiAction: "AI elkészíti a social media posztot",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz körmösként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak körmöket csinálhatsz, hanem digitális termékeket, kurzusokat és tanácsadást is értékesíthetsz",
      products: [
        {
          emoji: "💅",
          title: "Köröm Szolgáltatások",
          description: "Az alapod - ügyfeleid online foglalhatnak időpontot minden szolgáltatásodra",
          items: ["Gél lakk, manikűr", "Műköröm építés", "Köröm díszítések", "Pedikűr kezelések"],
        },
        {
          emoji: "💎",
          title: "Prémium Díszítések",
          description: "Magasabb árkategória - extra szolgáltatások",
          items: ["Swarovski kristályos díszítés", "Kézzel festett minták", "3D köröm művészet", "Esküvői köröm design"],
        },
        {
          emoji: "👥",
          title: "Workshopok",
          description: "Több embert érsz el egyszerre - magasabb bevétel, közösség építés",
          items: ["Otthoni körömápolás tanfolyam", "Gél lakk alapok workshop", "Lánybúcsú körmös est", "Díszítés masterclass"],
        },
        {
          emoji: "📚",
          title: "Digitális Termékek",
          description: "Passzív bevétel - egyszer készíted, folyamatosan értékesíted",
          items: ["Otthoni körömápolás útmutató", "Minta inspiráció e-book", "Technika videó kurzus", "Termék ajánlások katalógus"],
        },
        {
          emoji: "🎫",
          title: "Bérletek és Csomagok",
          description: "Stabil, előre látható bevétel - lojális ügyfelek garantálva",
          items: ["Havi köröm előfizetés", "VIP törzsvendég csomag", "Éves szépség program", "Ajándékutalványok"],
        },
      ],
    },
  },
  psychologists: {
    slug: "pszichologus",
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Online · Mindig elérhető",
        inputPlaceholder: "Írj egy üzenetet...",
        user1: "Készíts nekem egy weboldalt a szolgáltatásaimmal és módszereimmel!",
        ai1: "Kész! Elkészítettem az oldaladat 3 szekcióval: bemutatkozás, szolgáltatások és időpontfoglalás. Itt az elérhetőséged: harmonia-pszich.bespire.hu",
        user2: "Szerdán 16:00-ra foglalj be Nagy Évát egyéni konzultációra!",
        ai2: "Lefoglaltam! Nagy Éva - Egyéni konzultáció, szerda 16:00. Diszkrét értesítést is küldtem neki.",
        user3: "Küldj emailt azoknak akik érdeklődtek de nem foglaltak!",
        ai3: "Elkészítettem egy bátorító, diszkrét emailt és kiküldtem 15 potenciális kliensnek. Már 76%-os a megnyitási arány!",
        user4: "Köszi, ez fantasztikus! 😊",
        ai4: "Szívesen! Ha bármi kell, csak szólj. Weboldal, naptár, kliensek, marketing - te csak a klienseidre fókuszálj! 🧠",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      domain: "harmonia-pszich.bespire.hu",
      chatPrompt: "Építsd meg az oldalamat szolgáltatásokkal és módszerekkel!",
      aiMsg1: "Persze! Elkezdtem építeni az oldaladat. Néhány másodperc és kész is lesz...",
      aiMsg2: "Elkészültek a szekciók:",
      doneLabel: "Kész! Az oldalad él és elérhető:",
      userFollowUp: "Tudnád a színeket lilára és fehérre cserélni, nyugodtabb hangulatot adjon?",
      aiFollowUpReply: "Kész! Átállítottam a színeket lilára és fehérre. Nyugodt, professzionális hangulat! 🧘",
      blocks: {
        hero: "Bemutatkozás",
        services: "Szolgáltatások",
        pricing: "Időpontfoglalás és árak",
      },
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      synced: "Szinkronizálva",
      freeLabel: "Szabad",
      userAsk: "Holnap mik a szabad időpontjaim?",
      aiResponse: "Holnapi időpontjaid:",
      userBook: "Foglald le a 14:00-t Nagy Évának!",
      aiConfirm: "Kész! 14:00 lefoglalva Nagy Évának",
      notifSent: "Diszkrét értesítés elküldve a kliensnek",
      userThanks: "Köszönöm, szuper! 🙏",
      days: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      slots: {
        slot1: "Szabó K. - Egyéni konzultáció",
        slot2: "Kiss J. - Párterápia",
        slot3: "Tóth M. - Stresszkezelés",
        slot4: "",
        slot5: "",
      },
      newBookingNotif: "Új foglalás érkezett: Varga B. - Egyéni konzultáció 16:00",
    },
    clientsAnimation: {
      chatHeader: "Kliens Kezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd meg Nagy Éva profilját!",
      userAction: "Küldj neki emlékeztetőt a következő konzultációjáról!",
      aiConfirm: "Kész! Diszkrét emlékeztető elküldve Nagy Évának",
      visitsLabel: "alkalom",
      clients: {
        client1: { name: "Nagy Éva", tag: "Rendszeres", status: "Aktív terápia" },
        client2: { name: "Szabó Katalin", tag: "Új", status: "Első konzultáció" },
        client3: { name: "Kiss János", tag: "Rendszeres", status: "Párterápia" },
        client4: { name: "Tóth Márton", tag: "Visszatérő", status: "Follow-up" },
      },
      tabs: {
        profile: "Profil",
        history: "Előzmények",
        notes: "Jegyzetek",
      },
      timeline: {
        firstVisit: "Első konzultáció",
        program: "Szorongáskezelő program",
        session: "Konzultáció #18",
        renewal: "Program folytatás",
      },
      stats: {
        retention: "Megtartás",
        regularClients: "Rendszeres kliens",
        growth: "Növekedés",
      },
    },
    marketingAnimation: {
      chatHeader: "Marketing",
      title: "Marketing automatizálás",
      subtitle: "AI asszisztens",
      userAsk: "Küldj emailt az érdeklődőknek akik nem foglaltak!",
      aiCampaignIntro: "Elkészítettem a kampányt! Íme az email előnézet:",
      emailSubject: "Segíthetünk - az első lépés a legfontosabb",
      emailPreview: "Ingyenes bevezető konzultáció",
      emailCta: "Foglalok időpontot",
      userSend: "Küldd ki most! 🚀",
      aiSentConfirm: "Kiküldtem mind a 15 címre!",
      userReply: "Ez tökéletes! 🙏",
      sentLabel: "Kiküldve",
      opensLabel: "Megnyitás",
      funnel: {
        audience: "Célközönség",
        audienceDetail: "15 érdeklődő kliens",
        content: "Tartalom",
        contentDetail: "Bátorító email",
        sending: "Küldés",
        sendingDetail: "Kiküldve 15 címre",
        results: "Eredmények",
        resultsDetail: "76% megnyitás",
        resultTitle: "Kampány eredmény",
        live: "● Élő",
        conversions: "Új foglalás",
      },
    },
    teamAnimation: {
      chatHeader: "Praxis Kezelés",
      chatSubheader: "AI asszisztens · Online",
      inputPlaceholder: "Írj egy üzenetet...",
      user1: "Mutasd a mai csapatot! Ki dolgozik ma?",
      ai1: "Íme a mai praxis állapota:",
      user2: "Hogy állunk ma a konzultációkkal?",
      ai2: "Íme a mai statisztikák:",
      user3: "Dr. Kiss Éva beteg, oszd szét a klienseit a többiek között!",
      ai3: "Átszerveztem Dr. Kiss Éva 4 konzultációját a szabad szakemberekre.",
      user4: "Szuper, köszi! 🙌",
      ai4: "Szívesen! A klienseket is diszkréten értesítettem a szakemberváltásról. Minden szinkronban van! 🧠",
      reassignDone: "4 konzultáció átirányítva · 4 kliens értesítve",
      statsBookings: "Mai konzultáció",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Heti bevétel",
      staff: [
        { name: "Dr. Kovács Anna", role: "Klinikai pszichológus", status: "Elérhető" },
        { name: "Dr. Nagy Bence", role: "Párterapeuta", status: "Konzultáción" },
        { name: "Dr. Kiss Éva", role: "Gyermekpszichológus", status: "Beteg" },
        { name: "Dr. Szabó Petra", role: "Coach/mentor", status: "Elérhető" },
      ],
    },
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Solo pszichológusoknak és több szakemberes praxisoknak is.",
    heroImageAlt: "Pszichológus konzultációt tart",
    soloBadge: "Solo Pszichológusoknak",
    soloTitle: "Tökéletes egyéni pszichológusoknak",
    soloDescription: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az időpontokat, a klienseket, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Több Szakemberes Praxisoknak",
    teamTitle: "Komplex praxis kezelés egyszerűen",
    teamDescription: "Ha több szakember dolgozik a praxisban, a Bespire segít koordinálni a munkát.",
    teamImageAlt: "Pszichológus praxis csapat",
    phoneDemo: {
      businessName: "Harmónia Pszichológia",
      domain: "harmoniapszich.hu",
      serviceName: "Egyéni konzultáció",
      duration: "50 perc",
      price: "18.000 Ft",
      appointment: "Szerda, 16:00",
      therapist: "Dr. Kiss Éva",
      appointmentLabel: "Időpont",
      therapistLabel: "Pszichológus",
      confirmButton: "Foglalás megerősítése",
      url: "harmoniapszich.hu/foglalas",
      tagline: "Professzionális pszichológiai segítség",
      selectService: "Válassz szolgáltatást",
      services: [
        { name: "Egyéni konzultáció", duration: "50 perc", price: "18.000 Ft" },
        { name: "Párterápia", duration: "90 perc", price: "25.000 Ft" },
        { name: "Stresszkezelés", duration: "60 perc", price: "20.000 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["09:00", "10:00", "11:00", "14:00", "16:00", "18:00"],
      confirmed: "Foglalás megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk e-mailben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót a szolgáltatásaimmal és a módszereimmel",
        aiResponse: "Rendben! Készítettem egy szekciót a szolgáltatásoknak. Egyéni terápia, párterápia, stresszkezelés - mindegyikhez külön leírás. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza a szolgáltatások szekciót",
      },
      calendar: {
        userMessage: "Jövő héten mik a szabad időpontjaim új kliens fogadására?",
        aiResponse: "Jövő héten kedden 14:00, szerdán 10:00 és csütörtökön 16:00-kor van szabad időpontod 50 perces konzultációra. Foglaljak valakinek?",
        aiAction: "AI azonnal megmutatja a szabad időpontokat",
      },
      marketing: {
        userMessage: "Csinálj egy email-t azoknak akik érdeklődtek de nem foglaltak, emlékeztesd őket hogy segíthetek",
        aiResponse: "Találtam 15 potenciális klienst. Készítettem egy diszkrét, bátorító email-t. Küldjem el?",
        aiAction: "AI elkészíti a kampányt és célozza",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz pszichológusként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak konzultációkat tarthatsz, hanem digitális termékeket, kurzusokat és workshopokat is értékesíthetsz",
      products: [
        {
          emoji: "💬",
          title: "Konzultációk",
          description: "Az alapod - klienseid online foglalhatnak időpontot minden konzultációdra",
          items: [
            "Egyéni pszichológiai konzultáció",
            "Párterápia és családterápia",
            "Online konzultáció",
            "Krízis konzultáció",
          ],
        },
        {
          emoji: "🧠",
          title: "Terápiás Programok",
          description: "Magasabb árkategória - strukturált program",
          items: [
            "8 hetes szorongáskezelés",
            "Önértékelés fejlesztő program",
            "Stresszkezelés kurzus",
            "Burnout prevenció",
          ],
        },
        {
          emoji: "👥",
          title: "Csoportos Foglalkozások",
          description: "Több embert érsz el egyszerre - költséghatékony megoldás klienseknek",
          items: [
            "Csoportterápia",
            "Önismereti csoport",
            "Relaxációs workshop",
            "Kommunikációs tréning",
          ],
        },
        {
          emoji: "📚",
          title: "Digitális Termékek",
          description: "Passzív bevétel - egyszer készíted, folyamatosan értékesíted",
          items: [
            "Önismereti munkafüzet",
            "Meditációs hanganyagok",
            "Stresszkezelés e-book",
            "Napló és reflexió sablon",
          ],
        },
        {
          emoji: "🎫",
          title: "Terápiás Csomagok",
          description: "Stabil, előre látható bevétel - elkötelezett kliensek",
          items: [
            "5 alkalmas konzultáció csomag",
            "Havi támogatás program",
            "VIP intenzív csomag",
            "Follow-up csomagok",
          ],
        },
      ],
    },
  },
  nutritionConsultants: {
    slug: "taplalkozasi-tanacsado",
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Solo táplálkozási tanácsadóknak és több szakemberes csapatoknak is.",
    heroImageAlt: "Táplálkozási tanácsadó konzultációt tart",
    soloBadge: "Solo Táplálkozási Tanácsadóknak",
    soloTitle: "Tökéletes egyéni táplálkozási tanácsadóknak",
    soloDescription: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az időpontokat, az ügyfeleket, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Több Tanácsadós Csapatoknak",
    teamTitle: "Komplex táplálkozási központ kezelés egyszerűen",
    teamDescription: "Ha több szakember dolgozik a csapatban, a Bespire segít koordinálni a munkát.",
    teamImageAlt: "Táplálkozási tanácsadó csapat",
    phoneDemo: {
      businessName: "NutriBalance",
      domain: "nutribalance.hu",
      serviceName: "Étrend konzultáció",
      duration: "60 perc",
      price: "15.000 Ft",
      appointment: "Hétfő, 10:00",
      therapist: "Petra",
      appointmentLabel: "Időpont",
      therapistLabel: "Dietetikus",
      confirmButton: "Foglalás megerősítése",
      url: "nutribalance.hu/foglalas",
      tagline: "Személyre szabott táplálkozási tanácsadás",
      selectService: "Válassz szolgáltatást",
      services: [
        { name: "Étrend konzultáció", duration: "60 perc", price: "15.000 Ft" },
        { name: "Fogyókúra program", duration: "45 perc", price: "12.000 Ft" },
        { name: "Sportolói étrend", duration: "60 perc", price: "18.000 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["08:00", "09:30", "11:00", "13:00", "15:00", "17:00"],
      confirmed: "Foglalás megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk e-mailben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót a szolgáltatásaimmal és a programjaimmal",
        aiResponse: "Rendben! Készítettem egy szekciót a szolgáltatásoknak. Étrend konzultáció, fogyókúra program, sportolói étrend - mindegyikhez külön leírás. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza a szolgáltatások szekciót",
      },
      calendar: {
        userMessage: "Holnap mik a szabad időpontjaim étrend konzultációra?",
        aiResponse: "Holnap 9:00, 11:00 és 14:00-kor van szabad időpontod 60 perces étrend konzultációra. Foglaljak valakinek?",
        aiAction: "AI azonnal megmutatja a szabad időpontokat",
      },
      marketing: {
        userMessage: "Csinálj egy email kampányt az újévi fogadalmasoknak, kínálj nekik 20% kedvezményt a kezdő csomagra",
        aiResponse: "Készítettem egy motiváló kampányt az újévi célokról. Célcsoport: akik korábban érdeklődtek. Küldjük most?",
        aiAction: "AI elkészíti a kampányt és célozza",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz táplálkozási tanácsadóként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak konzultációkat tarthatsz, hanem digitális termékeket, kurzusokat és programokat is értékesíthetsz",
      products: [
        {
          emoji: "🥗",
          title: "Konzultációk",
          description: "Az alapod - ügyfeleid online foglalhatnak időpontot minden konzultációdra",
          items: [
            "Első találkozó és felmérés",
            "Haladás ellenőrzés",
            "Online konzultáció",
            "Kontroll vizit",
          ],
        },
        {
          emoji: "📋",
          title: "Étrend Programok",
          description: "Magasabb árkategória - komplett programok",
          items: [
            "Személyre szabott étrend",
            "12 hetes fogyókúra program",
            "Sportolói étrend összeállítás",
            "Egészséges életmód csomag",
          ],
        },
        {
          emoji: "👥",
          title: "Csoportos Programok",
          description: "Több embert érsz el egyszerre - költséghatékony megoldás",
          items: [
            "Csoportos fogyókúra kihívás",
            "Egészséges főzés workshop",
            "Táplálkozás alapok tanfolyam",
            "Életmódváltás program",
          ],
        },
        {
          emoji: "📚",
          title: "Digitális Termékek",
          description: "Passzív bevétel - egyszer készíted, folyamatosan értékesíted",
          items: [
            "Recept gyűjtemény PDF",
            "Étrend tervező sablon",
            "Kalória számláló útmutató",
            "Egészséges snack e-book",
          ],
        },
        {
          emoji: "🎫",
          title: "Előfizetések",
          description: "Stabil, előre látható bevétel - elkötelezett ügyfelek",
          items: [
            "Havi étrend előfizetés",
            "Negyedéves követés csomag",
            "VIP éves program",
            "Heti recept csomag",
          ],
        },
      ],
    },
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Táplálkozási Asszisztens · Online",
        user1: "Építs nekem egy weboldalt a szolgáltatásaimmal és étrendjeimmel!",
        ai1: "Máris! Készítek egy elegáns oldalt étrend konzultációkkal, programokkal és online foglalási lehetőséggel.",
        user2: "Állítsd be a naptáram, hogy hétfőn és szerdán fogadjak ügyfeleket.",
        ai2: "Kész! Hétfő és szerda beállítva konzultációs napoknak. Az ügyfelek online foglalhatnak.",
        user3: "Küldj egy emlékeztető emailt a holnapi ügyfeleknek az étrend konzultációjukról.",
        ai3: "Elküldtem! 5 ügyfélnek ment emlékeztető a holnapi konzultációról, időponttal és teendőkkel.",
        user4: "Szuper, köszönöm! 🙏",
        ai4: "Nincs mit! Ha bármire szükséged van, szólj! 🥗",
        inputPlaceholder: "Írj egy üzenetet...",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      chatPrompt: "Építs egy profi táplálkozási tanácsadó weboldalt szolgáltatásokkal és foglalási lehetőséggel!",
      aiMsg1: "Remek! Elemzem a profilodat és elkészítem a tökéletes weboldalt...",
      aiMsg2: "A következő szekciókat készítettem el:",
      blocks: {
        hero: "Bemutatkozás és szakterületek",
        services: "Étrend programok és árak",
        pricing: "Foglalási rendszer + vélemények",
      },
      doneLabel: "A weboldalad kész! Nézd meg itt:",
      domain: "nutribalance.bespire.hu",
      userFollowUp: "Adj hozzá egy recept blog szekciót is!",
      aiFollowUpReply: "Kész! Recept blog szekció hozzáadva, ahol egészséges recepteket és táplálkozási tippeket publikálhatsz. Szeretnél még módosítani?",
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      userAsk: "Mutasd a holnapi programomat konzultációkra!",
      aiResponse: "Holnapi naptár - Hétfő, Március 9:",
      slots: {
        slot1: "Kovács A. - Étrend felmérés",
        slot2: "Szabó K. - Fogyókúra kontroll",
        slot4: "Tóth M. - Sportolói étrend",
      },
      freeLabel: "Szabad",
      userBook: "Foglald le az 11:00-ás időpontot Kiss Évának étrend konzultációra!",
      aiConfirm: "Foglalva! Kiss Éva - Étrend konzultáció, 11:00. Megerősítő email elküldve.",
      notifSent: "Emlékeztető kiküldve az ügyfélnek",
      userThanks: "Szuper, köszi! 👍",
      newBookingNotif: "Új foglalás érkezett: Kiss É. - Étrend konzultáció 11:00",
    },
    clientsAnimation: {
      chatHeader: "Ügyfélkezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd Kovács Anna ügyfél adatlapját!",
      clients: {
        client1: {
          name: "Kovács Anna",
          tag: "VIP Ügyfél",
          status: "Aktív fogyókúra program",
        },
      },
      visitsLabel: "konzultáció",
      timeline: {
        firstMeeting: "Első konzultáció",
        strategyBought: "12 hetes program",
        lastSession: "Utolsó kontroll",
        renewal: "Program megújítás",
      },
      userAction: "Küldj neki egy személyes ajánlatot a tavaszi méregtelenítő programra!",
      aiConfirm: "Személyes ajánlat elküldve! A tavaszi méregtelenítő program részletei és kedvezményes ár benne van.",
      stats: {
        retention: "Megtartás",
        vipClients: "VIP ügyfelek",
        growth: "Növekedés",
      },
    },
    teamAnimation: {
      chatHeader: "Csapatkezelés",
      chatSubheader: "AI asszisztens · Online",
      user1: "Mutasd a dietetikus csapat mai státuszát!",
      ai1: "Íme a csapatod mai áttekintése:",
      staff: [
        { name: "Nagy Petra", role: "Vezető Dietetikus", status: "Elérhető" },
        { name: "Kiss Réka", role: "Sportdietetikus", status: "Konzultáción" },
        { name: "Szabó Luca", role: "Klinikai Dietetikus", status: "Szabadnapos" },
        { name: "Tóth Bence", role: "Táplálkozási Tanácsadó", status: "Elérhető" },
      ],
      user2: "Mi a mai foglaltság és bevétel?",
      ai2: "Mai összefoglaló:",
      statsBookings: "Konzultáció",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Bevétel",
      user3: "Szabó Luca holnapi ügyfeleit oszd át Nagy Petrának!",
      ai3: "Átszervezem a holnapi beosztást...",
      reassignDone: "4 konzultáció átütemezve Nagy Petrához. Ügyfelek értesítve.",
      user4: "Köszönöm!",
      ai4: "Szívesen! A csapat hatékonyan működik. Ha kell még valami, szólj! 🥗",
      inputPlaceholder: "Kérdezz a csapatodról...",
    },
  },
  physiotherapists: {
    slug: "gyogytornasz",
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Online · Mindig elérhető",
        inputPlaceholder: "Írj egy üzenetet...",
        user1: "Készíts nekem egy weboldalt kezelésekkel és árakkal!",
        ai1: "Kész! Elkészítettem az oldaladat 3 szekcióval: hero, kezelések és árlista. Itt az elérhetőséged: mozgasterapia.bespire.hu",
        user2: "Holnap 9-re foglalj be Tóth Máriát gerinc kezelésre!",
        ai2: "Lefoglaltam! Tóth Mária - Gerinc kezelés, holnap 9:00. Értesítést is küldtem neki.",
        user3: "Küldj emailt azoknak akik befejezték a kezelést, emlékeztesd őket a kontrollra!",
        ai3: "Elkészítettem a kampányt és kiküldtem 33 páciensnek. Már 85%-os a megnyitási arány!",
        user4: "Köszi, ez fantasztikus! 😍",
        ai4: "Szívesen! Ha bármi kell, csak szólj. Weboldal, naptár, páciensek, marketing - te csak gyógyíts! 🩺",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      domain: "mozgasterapia.bespire.hu",
      chatPrompt: "Építsd meg az oldalamat kezelésekkel és árakkal!",
      aiMsg1: "Persze! Elkezdtem építeni az oldaladat. Néhány másodperc és kész is lesz...",
      aiMsg2: "Elkészültek a szekciók:",
      doneLabel: "Kész! Az oldalad él és elérhető:",
      userFollowUp: "Tudnád a színeket teal és fehér kombóra cserélni?",
      aiFollowUpReply: "Kész! Átállítottam a színeket tealre és fehérre. Professzionális lett! 🏥",
      blocks: {
        hero: "Hero szekció",
        services: "Kezelések",
        pricing: "Árlista",
      },
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      synced: "Szinkronizálva",
      freeLabel: "Szabad",
      userAsk: "Holnap mik a szabad időpontjaim?",
      aiResponse: "Holnapi időpontjaid:",
      userBook: "Foglald le a 9:00-t Tóth Máriának!",
      aiConfirm: "Kész! 09:00 lefoglalva Tóth Máriának",
      notifSent: "Értesítés elküldve a páciensnek",
      userThanks: "Köszönöm, szuper! 👍",
      days: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      slots: {
        slot1: "Nagy P. - Gerinc kezelés",
        slot2: "Kovács A. - Sportrehabilitáció",
        slot3: "",
        slot4: "Kiss E. - Kontroll vizsgálat",
        slot5: "",
      },
      newBookingNotif: "Új foglalás: Szabó J. - Manuál terápia 14:00",
    },
    clientsAnimation: {
      chatHeader: "Páciens Kezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd meg Szabó János profilját!",
      userAction: "Küldj neki emlékeztetőt a kontroll vizsgálatra!",
      aiConfirm: "Kész! Emlékeztető elküldve Szabó Jánosnak",
      visitsLabel: "alkalom",
      clients: {
        client1: { name: "Szabó János", tag: "Visszatérő", status: "Aktív kezelés" },
        client2: { name: "Tóth Mária", tag: "Új", status: "Első vizsgálat" },
        client3: { name: "Kiss Éva", tag: "VIP", status: "Rehabilitáció" },
        client4: { name: "Nagy Péter", tag: "Visszatérő", status: "Kontroll" },
      },
      tabs: {
        profile: "Profil",
        history: "Előzmények",
        notes: "Jegyzetek",
      },
      timeline: {
        firstVisit: "Első vizsgálat",
        passBought: "10 alkalmas csomag",
        session: "Gerinc kezelés #8",
        renewal: "Csomag megújítás",
      },
      stats: {
        retention: "Megtartás",
        vipClients: "VIP páciens",
        growth: "Növekedés",
      },
    },
    marketingAnimation: {
      chatHeader: "Marketing",
      title: "Marketing automatizálás",
      subtitle: "AI asszisztens",
      userAsk: "Emlékeztesd a pácienseket akik befejezték a kezelést!",
      aiCampaignIntro: "Elkészítettem a kampányt! Íme az email előnézet:",
      emailSubject: "Ideje a kontroll vizsgálatnak!",
      emailPreview: "Kontroll vizsgálat emlékeztető",
      emailCta: "Foglalok!",
      userSend: "Küldd ki most! 🚀",
      aiSentConfirm: "Kiküldtem mind a 33 címre!",
      userReply: "Ez fantasztikus! 😍",
      sentLabel: "Kiküldve",
      opensLabel: "Megnyitás",
      funnel: {
        audience: "Célközönség",
        audienceDetail: "33 befejezett kezelés",
        content: "Tartalom",
        contentDetail: "Kontroll emlékeztető email",
        sending: "Küldés",
        sendingDetail: "Kiküldve 33 címre",
        results: "Eredmények",
        resultsDetail: "85% megnyitás",
        resultTitle: "Kampány eredmény",
        live: "● Élő",
        conversions: "Visszatérő",
      },
    },
    teamAnimation: {
      chatHeader: "Csapatkezelés",
      chatSubheader: "AI asszisztens · Online",
      inputPlaceholder: "Írj egy üzenetet...",
      user1: "Mutasd a mai csapatot! Ki dolgozik ma?",
      ai1: "Íme a mai csapat állapota:",
      user2: "Hogy állunk ma a foglalásokkal?",
      ai2: "Íme a mai statisztikák:",
      user3: "Dr. Kiss beteg, oszd szét a kezeléseit a többiek között!",
      ai3: "Átszerveztem Dr. Kiss 6 kezelését a szabad szakemberekre.",
      user4: "Szuper, köszi! 🙌",
      ai4: "Szívesen! A pácienseket is értesítettem a változásról. Minden szinkronban van! 🩺",
      reassignDone: "6 kezelés átirányítva · 4 páciens értesítve",
      statsBookings: "Mai foglalás",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Heti bevétel",
      staff: [
        { name: "Dr. Kovács Anna", role: "Gyógytornász", status: "Elérhető" },
        { name: "Dr. Nagy Bence", role: "Manuál terapeuta", status: "Kezelésen" },
        { name: "Dr. Kiss Réka", role: "Sportrehabilitáció", status: "Beteg" },
        { name: "Dr. Tóth Márk", role: "Gerincspecialista", status: "Elérhető" },
      ],
    },
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Solo gyógytornászoknak és több szakemberes klinikáknak is.",
    heroImageAlt: "Gyógytornász kezelést végez",
    soloBadge: "Solo Gyógytornászoknak",
    soloTitle: "Tökéletes egyéni gyógytornászoknak",
    soloDescription: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az időpontokat, a pácienseket, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Több Szakemberes Klinikáknak",
    teamTitle: "Komplex rehabilitációs klinika kezelés egyszerűen",
    teamDescription: "Ha több szakember dolgozik a klinikán, a Bespire segít koordinálni a munkát.",
    teamImageAlt: "Gyógytornász klinika csapat",
    phoneDemo: {
      businessName: "MozgásTerápia",
      domain: "mozgasterapia.hu",
      serviceName: "Gerinc kezelés",
      duration: "45 perc",
      price: "12.000 Ft",
      appointment: "Csütörtök, 09:00",
      therapist: "Tamás",
      appointmentLabel: "Időpont",
      therapistLabel: "Gyógytornász",
      confirmButton: "Foglalás megerősítése",
      url: "mozgasterapia.hu/foglalas",
      tagline: "Professzionális gyógytorna & rehabilitáció",
      selectService: "Válassz kezelést",
      services: [
        { name: "Gerinc kezelés", duration: "45 perc", price: "12.000 Ft" },
        { name: "Sportrehabilitáció", duration: "60 perc", price: "15.000 Ft" },
        { name: "Mozgásfejlesztés", duration: "30 perc", price: "8.000 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["08:00", "09:00", "10:00", "11:00", "14:00", "16:00"],
      confirmed: "Foglalás megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk SMS-ben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót a kezelések típusaival és az árakkal",
        aiResponse: "Rendben! Készítettem egy szekciót a kezeléseknek. Gerincterápia, sportrehabilitáció, mozgásfejlesztés - mindegyikhez külön leírás. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza a kezelések szekciót",
      },
      calendar: {
        userMessage: "Holnap délelőtt mik a szabad időpontjaim gerinc kezelésre?",
        aiResponse: "Holnap délelőtt 8:00, 9:00 és 10:30-kor van szabad időpontod 45 perces gerinc kezelésre. Foglaljak valakinek?",
        aiAction: "AI azonnal megmutatja a szabad időpontokat",
      },
      marketing: {
        userMessage: "Csinálj egy email kampányt azoknak akik befejezték a kezelést, emlékeztesd őket a kontroll vizsgálatra",
        aiResponse: "Találtam 33 pácienst akik 3 hónapja befejezték a kezelést. Email készült kontroll vizsgálat emlékeztetővel. Küldjük?",
        aiAction: "AI elkészíti a kampányt és célozza",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz gyógytornászként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak kezeléseket tarthatsz, hanem digitális termékeket, kurzusokat és programokat is értékesíthetsz",
      products: [
        {
          emoji: "🏥",
          title: "Kezelések",
          description: "Az alapod - pácienseid online foglalhatnak időpontot minden kezelésedre",
          items: [
            "Gerincterápia és manuál terápia",
            "Sportrehabilitáció",
            "Mozgásfejlesztés",
            "Kontroll vizsgálat",
          ],
        },
        {
          emoji: "📋",
          title: "Rehabilitációs Programok",
          description: "Magasabb árkategória - komplett gyógyulási programok",
          items: [
            "Gerinc rehabilitációs program",
            "Műtét utáni felépülés",
            "Sportolói visszatérés program",
            "Krónikus fájdalom kezelés",
          ],
        },
        {
          emoji: "👥",
          title: "Csoportos Foglalkozások",
          description: "Több embert érsz el egyszerre - prevenciós programok",
          items: [
            "Gerinctorna csoport",
            "Tartásjavító óra",
            "Irodai dolgozók tornája",
            "Senior mozgásprogram",
          ],
        },
        {
          emoji: "📚",
          title: "Digitális Termékek",
          description: "Passzív bevétel - egyszer készíted, folyamatosan értékesíted",
          items: [
            "Otthoni gyakorlat videók",
            "Gerincvédő útmutató PDF",
            "Nyújtási rutin csomag",
            "Ergonómiai tanácsok e-book",
          ],
        },
        {
          emoji: "🎫",
          title: "Kezelés Csomagok",
          description: "Stabil, előre látható bevétel - elköteleződő páciensek",
          items: [
            "10 alkalmas kezelés csomag",
            "Rehabilitációs csomag",
            "Havi fenntartó program",
            "VIP prioritásos ellátás",
          ],
        },
      ],
    },
  },
  sportsClubs: {
    slug: "sport-klub",
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Online · Mindig elérhető",
        inputPlaceholder: "Írj egy üzenetet...",
        user1: "Készíts nekem egy weboldalt az órákkal és az órarenddel!",
        ai1: "Kész! Elkészítettem az oldaladat 3 szekcióval: hero, órák és órarend. Itt az elérhetőséged: powerfit.bespire.hu",
        user2: "Ma este hány szabad hely van a CrossFit órán 18:00-kor?",
        ai2: "Ma este 18:00-kor a CrossFit órán még 6 szabad hely van a 15-ből. Foglaljak valakit?",
        user3: "Küldj kampányt az újévi fogadalmakhoz, 2 hét ingyenes próba!",
        ai3: "Elkészítettem a kampányt és kiküldtem 45 érdeklődőnek. Már 78%-os a megnyitási arány!",
        user4: "Szuper, köszönöm! 💪",
        ai4: "Szívesen! Ha bármi kell, csak szólj. Weboldal, naptár, tagok, marketing - te csak eddzél! 🏋️",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      domain: "powerfit.bespire.hu",
      chatPrompt: "Építsd meg az oldalamat az órarenddel és tagságokkal!",
      aiMsg1: "Persze! Elkezdtem építeni az oldaladat. Néhány másodperc és kész is lesz...",
      aiMsg2: "Elkészültek a szekciók:",
      doneLabel: "Kész! Az oldalad él és elérhető:",
      userFollowUp: "Tudnád a színeket narancsra és sötétszürkére cserélni?",
      aiFollowUpReply: "Kész! Átállítottam a színeket narancsra és sötétszürkére. Nézd meg az oldalon! 🎨",
      blocks: {
        hero: "Hero szekció",
        services: "Órák és órarend",
        pricing: "Tagságok és bérletek",
      },
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      synced: "Szinkronizálva",
      freeLabel: "Szabad",
      userAsk: "Holnap mik a szabad időpontok a teremben?",
      aiResponse: "Holnapi terem-foglalások:",
      userBook: "Foglald le a 8:00-t egy CrossFit órának!",
      aiConfirm: "Kész! 08:00 lefoglalva CrossFit órának (max 15 fő)",
      notifSent: "Értesítés elküldve a tagoknak",
      userThanks: "Köszönöm, szuper! 👍",
      days: ["H", "K", "Sze", "Cs", "P", "Szo", "V"],
      slots: {
        slot1: "CrossFit kezdő (12 fő)",
        slot2: "Spinning csoport (10 fő)",
        slot3: "TRX haladó (8 fő)",
        slot4: "HIIT edzés (15 fő)",
        slot5: "Jóga (6 fő)",
      },
      newBookingNotif: "Új foglalás érkezett: Kovács B. - CrossFit 18:00",
    },
    clientsAnimation: {
      chatHeader: "Tagkezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd meg Varga Gábor profilját!",
      userAction: "Küldj neki emlékeztetőt a lejáró bérletéről!",
      aiConfirm: "Kész! Emlékeztető elküldve Varga Gábornak",
      visitsLabel: "alkalom",
      clients: {
        client1: { name: "Varga Gábor", tag: "VIP", status: "Korlátlan tagság" },
        client2: { name: "Szabó Petra", tag: "Új", status: "Próba edzés" },
        client3: { name: "Nagy Tamás", tag: "VIP", status: "10 alkalmas" },
        client4: { name: "Kiss Eszter", tag: "Visszatérő", status: "Havi bérlet" },
      },
      tabs: {
        profile: "Profil",
        history: "Előzmények",
        notes: "Jegyzetek",
      },
      timeline: {
        firstVisit: "Első látogatás",
        passBought: "10 alkalmas bérlet",
        session: "CrossFit óra #42",
        renewal: "Tagság megújítás",
      },
      stats: {
        retention: "Megtartás",
        vipClients: "VIP tag",
        growth: "Növekedés",
      },
    },
    teamAnimation: {
      chatHeader: "Csapatkezelés",
      chatSubheader: "AI asszisztens · Online",
      inputPlaceholder: "Írj egy üzenetet...",
      user1: "Mutasd a mai csapatot! Ki dolgozik ma?",
      ai1: "Íme a mai csapat állapota:",
      user2: "Hogy állunk ma a foglalásokkal?",
      ai2: "Íme a mai statisztikák:",
      user3: "Molnár Péter beteg, oszd szét az óráit a többiek között!",
      ai3: "Átszerveztem Molnár Péter 6 óráját a szabad edzőkre.",
      user4: "Szuper, köszi! 🙌",
      ai4: "Szívesen! A tagokat is értesítettem az edzőváltásról. Minden szinkronban van! 💪",
      reassignDone: "6 óra átirányítva · 8 tag értesítve",
      statsBookings: "Mai foglalás",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Heti bevétel",
      staff: [
        { name: "Kovács Dániel", role: "CrossFit edző", status: "Elérhető" },
        { name: "Nagy Zsolt", role: "Személyi edző", status: "Edzésen" },
        { name: "Molnár Péter", role: "Csoportos edző", status: "Beteg" },
        { name: "Tóth Réka", role: "Spinning edző", status: "Elérhető" },
      ],
    },
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Kisebb sport kluboknak és nagyobb fitness termeknek is.",
    heroImageAlt: "Sport klub edzés",
    soloBadge: "Kisebb Kluboknak",
    soloTitle: "Tökéletes kisebb sport kluboknak",
    soloDescription: "Ha kisebb klubot vezetsz, a Bespire AI a tökéletes asszisztensed. Kezeli az órákat, a tagokat, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Nagyobb Fitness Termeknek",
    teamTitle: "Komplex fitness terem kezelés egyszerűen",
    teamDescription: "Ha több edző és sok tag van, a Bespire segít koordinálni a működést.",
    teamImageAlt: "Sport klub csapat",
    phoneDemo: {
      businessName: "PowerFit Gym",
      domain: "powerfit.hu",
      serviceName: "CrossFit óra",
      duration: "60 perc",
      price: "3.500 Ft",
      appointment: "Kedd, 18:00",
      therapist: "Gergő",
      appointmentLabel: "Időpont",
      therapistLabel: "Edző",
      confirmButton: "Jelentkezés megerősítése",
      url: "powerfit.hu/foglalas",
      tagline: "Csoportos órák & személyi edzés",
      selectService: "Válassz órát",
      services: [
        { name: "CrossFit óra", duration: "60 perc", price: "3.500 Ft" },
        { name: "Spinning", duration: "45 perc", price: "3.000 Ft" },
        { name: "TRX edzés", duration: "50 perc", price: "3.500 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["06:00", "07:30", "09:00", "17:00", "18:30", "20:00"],
      confirmed: "Jelentkezés megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk SMS-ben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót az órákkal és az órarenddel",
        aiResponse: "Rendben! Készítettem egy szekciót az óráknak. CrossFit, spinning, TRX - mindegyikhez külön leírás és órarend. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza az órák szekciót",
      },
      calendar: {
        userMessage: "Ma este hány szabad hely van a CrossFit órán?",
        aiResponse: "Ma este 18:00-kor a CrossFit órán még 6 szabad hely van a 15-ből. Foglaljak valakit?",
        aiAction: "AI azonnal megmutatja a szabad helyeket",
      },
      marketing: {
        userMessage: "Csinálj egy kampányt az új év elejére, kínálj 2 hét ingyenes próbát az új tagoknak",
        aiResponse: "Készítettem egy motiváló kampányt az újévi fogadalmakhoz. 2 hét ingyenes próba ajánlattal. Küldjük az érdeklődőknek?",
        aiAction: "AI elkészíti a kampányt és célozza",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz sport klubként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak órákat tarthatsz, hanem tagságokat, kiegészítőket és programokat is értékesíthetsz",
      products: [
        {
          emoji: "🏋️",
          title: "Órák és Edzések",
          description: "Az alapod - tagok online jelentkezhetnek minden órádra",
          items: [
            "CrossFit és funkcionális edzés",
            "Spinning és cardio órák",
            "TRX és erősítő edzés",
            "Jóga és stretching",
          ],
        },
        {
          emoji: "💪",
          title: "Személyi Edzés",
          description: "Magasabb árkategória - egyéni figyelem",
          items: [
            "Személyi edzés",
            "Duó edzés",
            "Kiscsoportos edzés",
            "Online coaching",
          ],
        },
        {
          emoji: "👥",
          title: "Speciális Programok",
          description: "Célorientált programok - magasabb elköteleződés",
          items: [
            "8 hetes átalakulás kihívás",
            "Nyári alakformáló program",
            "Versenyre felkészítés",
            "Kezdő bootcamp",
          ],
        },
        {
          emoji: "🛒",
          title: "Termékek",
          description: "Kiegészítő bevétel - webshop integráció",
          items: [
            "Protein és táplálékkiegészítők",
            "Edzés ruházat és felszerelés",
            "Klub merchandise",
            "Egészséges snackek",
          ],
        },
        {
          emoji: "🎫",
          title: "Tagságok és Bérletek",
          description: "Stabil, előre látható bevétel - lojális tagok",
          items: [
            "Havi korlátlan tagság",
            "10 alkalmas bérlet",
            "VIP éves tagság",
            "Céges csomag",
          ],
        },
      ],
    },
  },
  teachers: {
    slug: "terapeuta-coach",
    heroTitle: "AI asszisztens, ami segíti a mindennapokat",
    heroDescription: "Chat-alapon építed a weboldaladat, kezeled a naptárat és a marketinget - az AI mindent megért és segít neked. Solo terapeutáknak és coachoknak, valamint több szakemberes csapatoknak is.",
    heroImageAlt: "Terapeuta konzultációt tart",
    soloBadge: "Solo Terapeutáknak & Coachoknak",
    soloTitle: "Tökéletes egyéni terapeutáknak és coachoknak",
    soloDescription: "Ha egyedül dolgozol, a Bespire AI a tökéletes asszisztensed. Kezeli az üléseket, az ügyfeleket, a marketinget - te pedig csak azt csinálod, amit szeretsz.",
    teamBadge: "Több Szakemberes Csapatoknak",
    teamTitle: "Komplex terápiás és coaching központ kezelés egyszerűen",
    teamDescription: "Ha több terapeuta vagy coach dolgozik a csapatban, a Bespire segít koordinálni a munkát.",
    teamImageAlt: "Terápiás és coaching csapat",
    phoneDemo: {
      businessName: "Inner Balance",
      domain: "innerbalance.hu",
      serviceName: "Egyéni coaching ülés",
      duration: "60 perc",
      price: "15.000 Ft",
      appointment: "Hétfő, 10:00",
      therapist: "Andrea",
      appointmentLabel: "Időpont",
      therapistLabel: "Terapeuta",
      confirmButton: "Foglalás megerősítése",
      url: "innerbalance.hu/foglalas",
      tagline: "Terápia & coaching szolgáltatások",
      selectService: "Válassz szolgáltatást",
      services: [
        { name: "Egyéni coaching", duration: "60 perc", price: "15.000 Ft" },
        { name: "Csoportos terápia", duration: "90 perc", price: "8.000 Ft" },
        { name: "Online konzultáció", duration: "50 perc", price: "12.000 Ft" },
      ],
      selectTime: "Válassz időpontot",
      timeSlots: ["09:00", "10:00", "11:00", "14:00", "16:00", "18:00"],
      confirmed: "Foglalás megerősítve!",
      confirmedSubtext: "Emlékeztetőt küldünk e-mailben",
      browserLabel: "Böngészőből, app nélkül",
      noAppNeeded: "Nem kellett app letöltés!",
    },
    aiChatExamples: {
      website: {
        userMessage: "Adj hozzá egy szekciót a szolgáltatásaimmal és coaching programjaimmal",
        aiResponse: "Rendben! Készítettem egy szekciót. Egyéni coaching, csoportos terápia, online konzultáció - mindegyikhez külön leírás. Szeretnél módosítani rajta?",
        aiAction: "AI létrehozza a szolgáltatások szekciót",
      },
      calendar: {
        userMessage: "Jövő héten mik a szabad időpontjaim egyéni coaching ülésre?",
        aiResponse: "Jövő héten hétfőn 10:00, szerdán 14:00 és pénteken 11:00-kor van szabad időpontod 60 perces coaching ülésre. Foglaljak valakinek?",
        aiAction: "AI azonnal megmutatja a szabad időpontokat",
      },
      marketing: {
        userMessage: "Csinálj egy email kampányt az új coaching programomhoz, kínálj 15% kedvezményt az első ülésre",
        aiResponse: "Készítettem egy motiváló kampányt az új coaching programról. 15% kedvezmény az első ülésre. Célcsoport: korábbi érdeklődők. Küldjük?",
        aiAction: "AI elkészíti a kampányt és célozza",
      },
    },
    sellProducts: {
      title: "Mit értékesíthetsz terapeutaként vagy coachként?",
      description: "Több bevételi forrás, egy platformon - a Bespire-n nem csak üléseket tarthatsz, hanem digitális termékeket, programokat és workshopokat is értékesíthetsz",
      products: [
        {
          emoji: "🧘",
          title: "Ülések és Konzultációk",
          description: "Az alapod - ügyfelek online foglalhatnak minden szolgáltatásodra",
          items: [
            "Egyéni coaching ülés",
            "Párterápia",
            "Online konzultáció",
            "Follow-up ülés",
          ],
        },
        {
          emoji: "🎯",
          title: "Coaching Programok",
          description: "Magasabb árkategória - hosszú távú együttműködés",
          items: [
            "3 hónapos coaching csomag",
            "Életmódváltás program",
            "VIP intenzív hétvége",
            "Csoportos coaching program",
          ],
        },
        {
          emoji: "👥",
          title: "Workshopok és Csoportok",
          description: "Több embert érsz el egyszerre - közösségépítés",
          items: [
            "Önismereti workshop",
            "Stresszkezelés tréning",
            "Mindfulness csoport",
            "Fejlődési hétvége",
          ],
        },
        {
          emoji: "📚",
          title: "Digitális Termékek",
          description: "Passzív bevétel - egyszer készíted, folyamatosan értékesíted",
          items: [
            "Önismereti munkafüzet PDF",
            "Meditációs hanganyag",
            "Online kurzus csomag",
            "Coaching sablonok és eszközök",
          ],
        },
        {
          emoji: "🎫",
          title: "Bérletek és Előfizetés",
          description: "Stabil, előre látható bevétel - elkötelezett ügyfelek",
          items: [
            "Havi coaching csomag",
            "Negyedéves követés",
            "VIP éves program",
            "Online tartalom előfizetés",
          ],
        },
      ],
    },
    heroAnimation: {
      chat: {
        header: "Bespire AI Asszisztens",
        subheader: "Terápiás Asszisztens · Online",
        user1: "Építs nekem egy weboldalt a szolgáltatásaimmal és coaching programjaimmal!",
        ai1: "Máris! Készítek egy professzionális oldalt szolgáltatásokkal, programokkal és online foglalási lehetőséggel.",
        user2: "Állítsd be a naptáram, hogy hétfőtől péntekig délelőtt fogadjak ügyfeleket.",
        ai2: "Kész! Hétfő-péntek délelőtt beállítva. Az ügyfelek online foglalhatnak egyéni ülést vagy csoportos programot.",
        user3: "Küldj egy emlékeztető emailt a holnapi ügyfeleknek az ülésükről!",
        ai3: "Elküldtem! 6 ügyfélnek ment emlékeztető a holnapi ülésről és a teendőkről.",
        user4: "Szuper, köszönöm! 🙏",
        ai4: "Nincs mit! Ha bármire szükséged van, szólj! 🧘",
        inputPlaceholder: "Írj egy üzenetet...",
      },
    },
    websiteAnimation: {
      chatHeader: "Weboldal Építő",
      chatSubheader: "AI asszisztens",
      chatPrompt: "Építs egy profi terapeuta weboldalt szolgáltatásokkal és online foglalással!",
      aiMsg1: "Remek! Elemzem a profilodat és elkészítem a tökéletes weboldalt...",
      aiMsg2: "A következő szekciókat készítettem el:",
      blocks: {
        hero: "Bemutatkozás és szakterületek",
        services: "Szolgáltatások és árak",
        pricing: "Foglalás + vélemények",
      },
      doneLabel: "A weboldalad kész! Nézd meg itt:",
      domain: "innerbalance.bespire.hu",
      userFollowUp: "Adj hozzá egy ügyfél vélemények szekciót is!",
      aiFollowUpReply: "Kész! Vélemények szekció hozzáadva, ahol az ügyfeleid megoszthatják tapasztalataikat. Szeretnél még módosítani?",
    },
    calendarAnimation: {
      chatHeader: "Naptár Kezelés",
      month: "Március 2026",
      subtitle: "AI asszisztens",
      userAsk: "Mutasd a holnapi programomat!",
      aiResponse: "Holnapi naptár - Hétfő, Március 9:",
      slots: {
        slot1: "Kovács Anna - Egyéni coaching",
        slot2: "Kis csoport - Stresszkezelés",
        slot4: "Tóth Péter - Follow-up ülés",
      },
      freeLabel: "Szabad",
      userBook: "Foglald le a 11:00-ás időpontot Szabó Emmának egyéni coachingra!",
      aiConfirm: "Foglalva! Szabó Emma - Egyéni coaching, 11:00. Megerősítő email elküldve.",
      notifSent: "Emlékeztető kiküldve az ügyfélnek",
      userThanks: "Szuper, köszi! 👍",
      newBookingNotif: "Új foglalás érkezett: Szabó E. - Egyéni coaching 11:00",
    },
    clientsAnimation: {
      chatHeader: "Ügyfélkezelés",
      chatSubheader: "AI asszisztens",
      userAsk: "Mutasd Kovács Anna ügyfél adatlapját!",
      clients: {
        client1: {
          name: "Kovács Anna",
          tag: "VIP Ügyfél",
          status: "Aktív coaching program",
        },
      },
      visitsLabel: "ülés",
      timeline: {
        firstMeeting: "Első konzultáció",
        strategyBought: "Coaching csomag",
        lastSession: "Utolsó ülés",
        renewal: "Program megújítás",
      },
      userAction: "Küldj neki egy személyes ajánlatot a tavaszi megújulás programra!",
      aiConfirm: "Személyes ajánlat elküldve! A tavaszi megújulás program részletei és kedvezményes ár benne van.",
      stats: {
        retention: "Megtartás",
        vipClients: "VIP ügyfelek",
        growth: "Növekedés",
      },
    },
    teamAnimation: {
      chatHeader: "Csapatkezelés",
      chatSubheader: "AI asszisztens · Online",
      user1: "Mutasd a terápiás csapat mai státuszát!",
      ai1: "Íme a csapatod mai áttekintése:",
      staff: [
        { name: "Kiss Andrea", role: "Life Coach", status: "Elérhető" },
        { name: "Szabó Márton", role: "Családterapeuta", status: "Ülésen" },
        { name: "Tóth Katalin", role: "Stresszkezelő", status: "Szabadnapos" },
        { name: "Varga Zsófi", role: "Mindfulness Coach", status: "Elérhető" },
      ],
      user2: "Mi a mai foglaltság és ülések száma?",
      ai2: "Mai összefoglaló:",
      statsBookings: "Ülés",
      statsUtilization: "Kihasználtság",
      statsRevenue: "Bevétel",
      user3: "Tóth Katalin holnapi ügyfeleit oszd át Kiss Andreának!",
      ai3: "Átszervezem a holnapi beosztást...",
      reassignDone: "4 ülés átütemezve Kiss Andreához. Ügyfelek értesítve.",
      user4: "Köszönöm!",
      ai4: "Szívesen! A csapat hatékonyan működik. Ha kell még valami, szólj! 🧘",
      inputPlaceholder: "Kérdezz a csapatodról...",
    },
  },
  pageUi: {
    breadcrumb: {
      home: "Főoldal",
      forWhom: "Kinek való?",
    },
    hero: {
      badgePrefix: "Bespire",
      soloTag: "✓ Solo {prof}eknek",
      teamTag: "✓ {min}–{max}+ fős csapatoknak",
      ctaPrimary: "Indítsd el most – ingyen",
      ctaCallback: "Hívjanak vissza",
      noCard: "Nincs bankkártya",
      trial: "3 nap ingyen · 30 ajándék AI kredit",
    },
    valueProps: {
      badge: "Miért Bespire?",
      title: "Amiért a {profPlural}",
      titleHighlight: "Bespire-t választják",
    },
    scales: {
      badge: "Egy AI asszisztens, két méret",
      title: "Skálázódik veled — egytől {max}+ szakemberig",
      subtitle: "Akár egyedül dolgozol, akár csapatban — ugyanaz a fiók, ugyanaz az ár. Korlátlan munkatárs, mindenki saját nézettel, te a teljes átláthatósággal.",
      soloDayTitle: "Egy nap egy {prof} életében",
      teamDayTitle: "Egy nap a {teamLabel} tulajdonosaként",
      soloGains: "Amit egyedül dolgozva nyersz",
      teamGains: "Amit csapatban dolgozva nyersz",
      noUpcharge: "Nem fizetsz többet a csapatért.",
      noUpchargeBody: "Akár 1, akár {max}+ szakember — ugyanaz a 13 900 Ft + ÁFA / hó. Korlátlan munkatárs, korlátlan ügyfél.",
    },
    howItWorks: {
      badge: "Hogy működik?",
      title: "4 lépésben élő, {profGen} oldal",
      subtitle: "Indítsd el chatben 10 perc alatt — vagy mi beüzemeljük 30 perc alatt.",
    },
    monetization: {
      badge: "Bevételi források",
      title: "Mit értékesíthetsz {profGen}ként?",
      subtitle: "Valós magyar piaci árakkal kalibrált példák. Egy AI asszisztens kezeli az egészet — nem külön eszközök.",
    },
    integrations: {
      worksWith: "Működik a meglévő",
      tools: "eszközeiddel.",
    },
    objections: {
      badge: "Gyakori aggályok",
      title: "Tisztázzuk őket",
    },
    pricing: {
      badge: "Egyszerű árazás",
      price: "13 900 Ft",
      priceUnit: "+ ÁFA / hó",
      description: "Teljes körű AI asszisztens: brand, weboldal, blog/SEO, marketing, email, foglalás, CRM, csapat — egy helyen. 50 AI kredit / hó, korlátlan munkatárs, korlátlan ügyfél. 3 nap ingyenes próba, 30 ajándék kredit, bankkártya nélkül.",
      bullet1: "1–{max}+ szakember egy fiókban",
      bullet2: "Brand, weboldal, blog, marketing, email, foglalás, CRM egyben",
      bullet3: "Magyar nyelvű támogatás, EU szerver",
      detailedCta: "Részletes árazás",
    },
    setup: {
      badge: "Két út a célhoz",
      title: "Csináld magad — vagy mi beüzemelünk",
      diyBadge: "10 perc",
      diyTitle: "DIY — chatben felépíted",
      diyBody: "Beszélgetsz az AI asszisztenssel magyarul, ő mindent megcsinál: brand, oldal, blog, marketing, foglalás, email, CRM. 3 nap ingyenes próba, 30 ajándék kredit, bankkártya nélkül.",
      diyBullet1: "Élő oldal 10 perc alatt",
      diyBullet2: "Nincs bankkártya induláshoz",
      diyBullet3: "Mindig módosíthatod chatben",
      diyCta: "Indítsd el most",
      doneBadge: "30 perc",
      doneTitle: "Beüzemelés — mi csináljuk",
      doneBody: "Átvesszük a meglévő rendszerből az ügyfeleket, bérleteket, kalendáriumot. Mire fel ébredsz másnap, élő minden.",
      formName: "Neved",
      formPhone: "Telefonszám",
      formCta: "Kérek visszahívást",
      formFootnote: "Munkanapokon 24 órán belül hívunk vissza.",
      thankYou: "Köszönjük! 24 órán belül hívunk a megadott számon.",
    },
    similar: {
      badge: "Hasonló szakmák",
      title: "Nekik is jól jön a Bespire",
    },
    aiScope: {
      badge: "Egy AI asszisztens — nem csak foglalás és weboldal",
      title: "Mindent, amihez eddig 8-10 külön eszközt használtál",
      subtitle: "Egy chat, egy fiók, egy havidíj. Az AI asszisztens az egész digitális működésedet viszi — nem csak a foglalást és a weboldalt.",
      overrideNote: "Példák {profGen}",
      categories: [
        {
          key: "brand",
          icon: "Globe",
          label: "Brand & weboldal",
          defaults: [
            "Logó, színek, saját domain 10 perc alatt",
            "Új szolgáltatás vagy ár chatben, azonnal élesben",
            "Előtte-utána galéria és vélemények automatikusan",
          ],
        },
        {
          key: "booking",
          icon: "Calendar",
          label: "Foglalás & bérlet",
          defaults: [
            "Online + helyszíni fizetés, automata számlával",
            "Csomagok, bérletek, várólista, no-show védelem",
            "Google Naptár és Meet szinkron",
          ],
        },
        {
          key: "content",
          icon: "Sparkles",
          label: "AI tartalom & social",
          defaults: [
            "Heti Instagram-, Facebook- és TikTok-poszt terv",
            "Hashtag-, leírás- és képötlet minden posztra",
            "Storyboard reelekhez és rövid videókhoz",
          ],
        },
        {
          key: "seo",
          icon: "TrendingUp",
          label: "SEO & Google Cégem",
          defaults: [
            "Blog- és szolgáltatás-oldalak a helyi kulcsszavakra",
            "Google Cégem posztok és képek automatán",
            "Meta-címek, alt-szövegek, sitemap gondozva",
          ],
        },
        {
          key: "email",
          icon: "Mail",
          label: "E-mail & WhatsApp",
          defaults: [
            "Visszaigazoló és 24 órás emlékeztető sablonok",
            "Utókövetés, elégedettség-mérés, értékelés-kérés",
            "Visszahívó kampány az inaktív ügyfeleknek",
          ],
        },
        {
          key: "crm",
          icon: "Users",
          label: "Ügyfél-CRM",
          defaults: [
            "Minden ügyfélnek profil, előzmény, jegyzet",
            "Forrás-követés: honnan jött, mennyit hozott",
            "Bérlet-státusz és lejárati figyelmeztetés",
          ],
        },
        {
          key: "analytics",
          icon: "BarChart3",
          label: "Analitika & döntés",
          defaults: [
            "Heti bevétel-, kihasználtság- és forrás-riport",
            "Melyik szolgáltatás/csatorna hozza a foglalást",
            "AI-javaslat árra, időpontra, kampányra",
          ],
        },
        {
          key: "team",
          icon: "ShieldCheck",
          label: "Csapat & jogosultság",
          defaults: [
            "Korlátlan munkatárs, ugyanaz a havidíj",
            "Szerep-alapú hozzáférés: tulaj, manager, kolléga",
            "Teljesítmény és bevétel munkatársanként",
          ],
        },
      ],
    },
    chatExampleAria: "5 csillag",
    fiveStars: "5 csillag",
  },
};
